<template>
  <div id="plannerAssignStudent">
    <div class="container" style="margin-top: 10px">
      <div class="pb-5">
        <el-tabs id="plannerAssignStudentPageElTab" v-model="eltabActive" closable @edit="handleTabsEdit" @tab-click="changeTab('')">
          <el-tab-pane :label="lang('Student List')" name="etpStudentList">
            <div class="row">
              <div class="col-lg-6 text-left">
                <label>{{ lang('Student List') }}</label>
              </div>
              <div class="col-lg-6 actionDiv">
                <el-select
                  v-model="ddlClass"
                  :placeholder="lang('Select Class')"
                  class="pro-edt-select"
                  @change="ClassChange()"
                  style="margin-right: 10px"
                  id="ddlClass"
                >
                  <el-option
                    v-for="item in ddlClassList"
                    :key="item.PK_Semester_ID + ',' + item.SC_FK_CourseID + ',' + item.CLS_ClassName"
                    :label="item.CLS_ClassName + ' (' + item.SMT_Year + ')'"
                    :value="item.PK_Semester_ID + ',' + item.SC_FK_CourseID + ',' + item.CLS_ClassName"
                  >
                  </el-option>
                </el-select>

                <el-select
                  v-model="ddlSemesterDetails"
                  :placeholder="lang('Select Term')"
                  class="pro-edt-select"
                  @change="LoadClassList('')"
                  id="ddlSemesterDetails"
                >
                  <el-option v-for="item in ddlSemesterDetailsList" :key="item.PK_SEMD_ID" :label="item.SEMD_DetailName" :value="item.PK_SEMD_ID"> </el-option>
                </el-select>
              </div>
            </div>
            <hr class="layoutAlpGrey" v-if="multipleStudentSelection.length > 0" />
            <div class="row" v-if="multipleStudentSelection.length > 0">
              <div class="col-lg-12 divAssignMultipleStudent">
                <el-button type="primary" class="mt-2 mb-2" @click="assignMultipleStudent()" id="btnAssignMultipleStudents">
                  {{ lang('Assign Multiple Students') }}
                </el-button>
                <el-button type="primary" class="mt-2 mb-2" @click="downloadPlanner()" id="btnDownload">
                  {{ lang('Download') }}
                </el-button>
              </div>
            </div>
            <hr class="layoutAlpGrey" />
            <div class="row">
              <div class="col-lg-12" v-if="isLoading">
                <div class="lds-ellipsis">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
              <div class="col-lg-12" v-if="!isLoading" :class="selectStudentTour && tourRunning ? 'redBorder' : ''" id="divDtudentPlannerSummary">
                <div class="empty-list_image" v-if="studentPlannerSummaryInt.length < 1">
                  <strong>{{ lang('No Data Found') }}...</strong>
                  <img src="../assets/notfound.png" />
                </div>
                <div v-if="studentPlannerSummaryInt.length > 0" class="datatable_group">
                  <data-tables :data="studentPlannerSummaryInt" @selection-change="changeStudentSelection" :pagination-props="{ pageSizes: [100, 200, 300] }">
                    <el-table-column type="selection" width="55" :reserve-selection="true" :selectable="checkSelectable"> </el-table-column>
                    <el-table-column
                      v-for="studentPlannerSummaryInfo in studentPlannerSummary"
                      :prop="studentPlannerSummaryInfo.prop"
                      :label="lang(studentPlannerSummaryInfo.label)"
                      :key="studentPlannerSummaryInfo.prop"
                      sortable="custom"
                    >
                    </el-table-column>
                    <!--                                        <el-table-column label="Action" min-width="100px">-->
                    <!--                                            <template slot-scope="scope">-->
                    <!--                                                &lt;!&ndash;<el-button type="primary" @click="assignStudent(scope.row)" :disabled="scope.row.Status === 'Pending'">&ndash;&gt;-->
                    <!--                                                    &lt;!&ndash;Assign&ndash;&gt;-->
                    <!--                                                &lt;!&ndash;</el-button>&ndash;&gt;-->
                    <!--                                                <el-button type="primary" @click="assignStudent(scope.row)" v-if="scope.row.Status === 'Active'">-->
                    <!--                                                    {{lang('Assign')}}-->
                    <!--                                                </el-button>-->
                    <!--                                                <el-button type="primary" @click="cancelPendingApprover(scope.row)" v-if="scope.row.Status === 'Pending'">-->
                    <!--                                                    {{lang('Cancel Pending Approver')}}-->
                    <!--                                                </el-button>-->
                    <!--                                            </template>-->
                    <!--                                        </el-table-column>-->
                    <el-table-column label="View" min-width="100px">
                      <template slot-scope="scope">
                        <el-button type="primary" @click="viewProgress(scope.row)" v-if="scope.row.Status === 'Active'">
                          {{ lang('Progress') }}
                        </el-button>
                      </template>
                    </el-table-column>
                  </data-tables>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane v-for="item in tabDetails" :label="item.TabLabel" :name="item.TabName" :key="item.TabName">
            <div class="row">
              <div class="col-lg-12 text-left" id="assigningStudentName">
                <label>{{ lang('Student Name') }}:</label>
              </div>
              <div class="col-lg-12 text-left">
                <label>{{ item.StudentFullName }}</label>
              </div>
            </div>
            <hr class="layoutAlpGrey" />
            <div class="row">
              <div class="col-lg-12" v-if="isLoading">
                <div class="lds-ellipsis">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
              <div class="col-lg-12" v-if="!isLoading">
                <div class="row">
                  <div class="col-lg-6">
                    <b-card no-body class="bcardStudentAssignStudent">
                      <b-tabs pills card>
                        <b-tab :title="lang('Learning Goals List')" active
                          ><b-card-text>
                            <div class="empty-list_image" v-if="masterPlannerList.length < 1">
                              <strong>{{ lang('No Data Found') }}...</strong>
                              <img src="../assets/notfound.png" />
                            </div>
                            <div v-if="masterPlannerList.length > 0">
                              <div class="divMasterPlannerListDesc">
                                <i class="material-icons">check_circle</i><label class="labelDisplayInline"> = {{ lang('Suggested') }}</label>
                              </div>
                              <div class="divSearchMasterPlannerList filterArea">
                                <div class="filterAreaDropDown">
                                  <el-select
                                    v-model="ddlSearchMasterPlannerList"
                                    @change="filterMasterPlannerList()"
                                    :placeholder="lang('Filter By')"
                                    class="pro-edt-select filterDDL"
                                  >
                                    <el-option v-for="item in ddlSearchMasterPlannerListList" :key="item.Domain" :label="item.Domain" :value="item.Domain">
                                    </el-option>
                                  </el-select>
                                </div>
                                <div class="filterAreaInput">
                                  <input
                                    type="text"
                                    class="form-control inputKeySkillCLD"
                                    v-model="inputSearchMasterPlannerList"
                                    :placeholder="lang('Search Indicator')"
                                    @change="filterMasterPlannerList()"
                                  />
                                </div>
                              </div>
                              <data-tables :data="filterMasterPlannerList()" :pagination-props="{ pageSizes: [100, 200, 300] }">
                                <el-table-column
                                  v-for="masterPlannerInfo in masterPlanner"
                                  :prop="masterPlannerInfo.prop"
                                  :label="lang(masterPlannerInfo.label)"
                                  :key="masterPlannerInfo.prop"
                                  sortable="custom"
                                >
                                </el-table-column>
                                <el-table-column label="" width="40px">
                                  <template slot-scope="scope">
                                    <i class="material-icons" v-if="scope.row.Type === 'Suggested'">check_circle</i>
                                  </template>
                                </el-table-column>
                                <el-table-column label="" width="40px">
                                  <template slot-scope="scope">
                                    <i class="material-icons assignedPlannerAdd" @click="AddPlanner(scope.row, 'normal')">add</i>
                                  </template>
                                </el-table-column>
                                <el-table-column label="" width="80px">
                                  <template slot-scope="scope">
                                    <div class="grid-container">
                                      <div :class="{ 'grid-item-1': checkContain(scope.row.AssignedPassTerms, '0') }" class="grid-item">1</div>
                                      <div :class="{ 'grid-item-2': checkContain(scope.row.AssignedPassTerms, '1') }" class="grid-item">2</div>
                                      <div :class="{ 'grid-item-3': checkContain(scope.row.AssignedPassTerms, '2') }" class="grid-item">3</div>
                                      <div :class="{ 'grid-item-4': checkContain(scope.row.AssignedPassTerms, '3') }" class="grid-item">4</div>
                                    </div>
                                  </template>
                                </el-table-column>
                              </data-tables>
                            </div>
                          </b-card-text></b-tab
                        >
                        <b-tab :title="lang('Other List')"
                          ><b-card-text>
                            <div class="empty-list_image" v-if="masterPlannerOtherList.length < 1">
                              <strong>{{ lang('No Data Found') }}...</strong>
                              <img src="../assets/notfound.png" />
                            </div>
                            <div v-if="masterPlannerOtherList.length > 0">
                              <div class="divMasterPlannerListDesc">
                                <label class="labelDisplayInline">&nbsp;</label>
                              </div>
                              <div class="divSearchMasterPlannerList filterArea">
                                <div class="filterAreaDropDown">
                                  <el-select
                                    v-model="ddlSearchMasterPlannerOther"
                                    @change="filterMasterPlannerOtherList()"
                                    :placeholder="lang('Filter By')"
                                    class="pro-edt-select filterDDL"
                                  >
                                    <el-option v-for="item in ddlSearchMasterPlannerOtherList" :key="item.Domain" :label="item.Domain" :value="item.Domain">
                                    </el-option>
                                  </el-select>
                                </div>
                                <div class="filterAreaInput">
                                  <input
                                    type="text"
                                    class="form-control inputKeySkillCLD"
                                    v-model="inputSearchMasterPlannerOther"
                                    :placeholder="lang('Search Indicator')"
                                    @change="filterMasterPlannerOtherList()"
                                  />
                                </div>
                              </div>
                              <data-tables :data="filterMasterPlannerOtherList()" :pagination-props="{ pageSizes: [100, 200, 300] }">
                                <el-table-column
                                  v-for="masterPlannerOtherInfo in masterPlannerOther"
                                  :prop="masterPlannerOtherInfo.prop"
                                  :label="lang(masterPlannerOtherInfo.label)"
                                  :key="masterPlannerOtherInfo.prop"
                                  sortable="custom"
                                >
                                </el-table-column>
                                <el-table-column label="" width="40px">
                                  <template slot-scope="scope">
                                    <i class="material-icons assignedPlannerAdd" @click="AddPlanner(scope.row, 'normal')">add</i>
                                  </template>
                                </el-table-column>
                                <el-table-column label="" width="80px">
                                  <template slot-scope="scope">
                                    <div class="grid-container">
                                      <div :class="{ 'grid-item-1': checkContain(scope.row.AssignedPassTerms, '0') }" class="grid-item">1</div>
                                      <div :class="{ 'grid-item-2': checkContain(scope.row.AssignedPassTerms, '1') }" class="grid-item">2</div>
                                      <div :class="{ 'grid-item-3': checkContain(scope.row.AssignedPassTerms, '2') }" class="grid-item">3</div>
                                      <div :class="{ 'grid-item-4': checkContain(scope.row.AssignedPassTerms, '3') }" class="grid-item">4</div>
                                    </div>
                                  </template>
                                </el-table-column>
                              </data-tables>
                            </div>
                          </b-card-text></b-tab
                        >
                        <b-tab :title="lang('Other Level List')"
                          ><b-card-text>
                            <div class="empty-list_image" v-if="masterPlannerListOtherLevel.length < 1">
                              <strong>{{ lang('No Data Found') }}...</strong>
                              <img src="../assets/notfound.png" />
                            </div>
                            <div v-if="masterPlannerListOtherLevel.length > 0">
                              <div class="divMasterPlannerListDesc">
                                <div class="row">
                                  <div class="col-lg-6">
                                    <i class="material-icons">looks_one</i><label class="labelDisplayInline"> = {{ lang('Learning Goals') }}</label>
                                  </div>
                                  <div class="col-lg-6">
                                    <i class="material-icons">looks_two</i><label class="labelDisplayInline"> = {{ lang('Other') }}</label>
                                  </div>
                                </div>
                              </div>
                              <div class="divSearchMasterPlannerList filterArea">
                                <div class="filterAreaDropDown">
                                  <el-select
                                    v-model="ddlSearchMasterOtherLevelPlannerListType"
                                    @change="filterMasterOtherLevelPlannerList()"
                                    :placeholder="lang('Filter Type')"
                                    class="pro-edt-select filterDDL"
                                  >
                                    <el-option v-for="item in ddlSearchMasterOtherLevelPlannerListTypeList" :key="item" :label="item" :value="item">
                                    </el-option>
                                  </el-select>
                                </div>
                                <div class="filterAreaDropDown">
                                  <el-select
                                    v-model="ddlSearchMasterOtherLevelPlannerList"
                                    @change="filterMasterOtherLevelPlannerList()"
                                    :placeholder="lang('Filter By')"
                                    class="pro-edt-select filterDDL"
                                  >
                                    <el-option
                                      v-for="item in ddlSearchMasterOtherLevelPlannerListList"
                                      :key="item.Domain"
                                      :label="item.Domain"
                                      :value="item.Domain"
                                    >
                                    </el-option>
                                  </el-select>
                                </div>
                                <div class="filterAreaDropDown">
                                  <el-select
                                    v-model="ddlSearchMasterOtherLevelPlannerListLevel"
                                    @change="filterMasterOtherLevelPlannerList()"
                                    :placeholder="lang('Filter Level')"
                                    class="pro-edt-select filterDDL"
                                  >
                                    <el-option
                                      v-for="item in ddlSearchMasterOtherLevelPlannerListLevelList"
                                      :key="item.Level"
                                      :label="item.Level"
                                      :value="item.Level"
                                    >
                                    </el-option>
                                  </el-select>
                                </div>
                                <div class="filterAreaInput">
                                  <input
                                    type="text"
                                    class="form-control inputKeySkillCLD"
                                    v-model="inputSearchMasterOtherLevelPlannerList"
                                    :placeholder="lang('Search Indicator')"
                                    @change="filterMasterOtherLevelPlannerList()"
                                  />
                                </div>
                              </div>
                              <data-tables :data="filterMasterOtherLevelPlannerList()" :pagination-props="{ pageSizes: [100, 200, 300] }">
                                <el-table-column
                                  v-for="masterPlannerInfo in masterPlannerOtherLevel"
                                  :prop="masterPlannerInfo.prop"
                                  :label="lang(masterPlannerInfo.label)"
                                  :key="masterPlannerInfo.prop"
                                  sortable="custom"
                                >
                                </el-table-column>
                                <el-table-column label="" width="40px">
                                  <template slot-scope="scope">
                                    <i class="material-icons" v-if="scope.row.Type === 'OtherLevelITL'">looks_one</i>
                                    <i class="material-icons" v-if="scope.row.Type === 'OtherLevelOther'">looks_two</i>
                                  </template>
                                </el-table-column>
                                <el-table-column label="" width="40px">
                                  <template slot-scope="scope">
                                    <i class="material-icons assignedPlannerAdd" @click="AddPlanner(scope.row, 'normal')">add</i>
                                  </template>
                                </el-table-column>
                                <el-table-column label="" width="80px">
                                  <template slot-scope="scope">
                                    <div class="grid-container">
                                      <div :class="{ 'grid-item-1': checkContain(scope.row.AssignedPassTerms, '0') }" class="grid-item">1</div>
                                      <div :class="{ 'grid-item-2': checkContain(scope.row.AssignedPassTerms, '1') }" class="grid-item">2</div>
                                      <div :class="{ 'grid-item-3': checkContain(scope.row.AssignedPassTerms, '2') }" class="grid-item">3</div>
                                      <div :class="{ 'grid-item-4': checkContain(scope.row.AssignedPassTerms, '3') }" class="grid-item">4</div>
                                    </div>
                                  </template>
                                </el-table-column>
                              </data-tables>
                            </div>
                          </b-card-text></b-tab
                        >
                        <b-tab :title="lang('New List')"
                          ><b-card-text>
                            <div class="row">
                              <div class="col-lg-12 divSelectDomain">
                                <label>{{ lang(lblDomain) }}</label>
                                <el-select v-model="dllDomain" @change="LoadGoals()" placeholder="Select Domain" class="pro-edt-select dllDomain">
                                  <el-option v-for="item in ddlDomainList" :key="item.Domain" :label="item.Domain" :value="item.Domain"> </el-option>
                                </el-select>
                              </div>
                              <div class="col-lg-12 divSelectGoals">
                                <label>{{ lang(lblGoals) }}</label>
                                <el-select v-model="ddlGoals" placeholder="Select Goals" class="pro-edt-select ddlGoals">
                                  <el-option v-for="item in ddlGoalsList" :key="item.Goals" :label="item.Goals" :value="item.Goals"> </el-option>
                                </el-select>
                              </div>
                              <div class="col-lg-12 divKeyInKeySkillorCld">
                                <label>{{ lang(lblIndicator) }}</label>
                                <input type="text" class="form-control inputKeySkillCLD" v-model="indicator" />
                              </div>
                              <div class="col-lg-12" v-if="dllDomain !== '' && ddlGoals !== '' && indicator !== ''">
                                <el-button type="primary" class="mt-2 mb-2" @click="AddSelfPlanner()">
                                  {{ lang('Add') }}
                                </el-button>
                              </div>
                            </div>
                          </b-card-text></b-tab
                        >
                        <b-tab :title="lang('Copy')" id="btnCopy"
                          ><b-card-text>
                            <div class="row">
                              <div class="col-lg-12 divCopySelectClass">
                                <label>{{ lang('Select Class') }}</label>
                                <el-select
                                  v-model="ddlCopyClass"
                                  :placeholder="lang('Select Class')"
                                  class="pro-edt-select ddlCopyClass"
                                  @change="CopyClassChange()"
                                  style="margin-right: 10px"
                                >
                                  <el-option
                                    v-for="item in ddlCopyClassList"
                                    :key="item.PK_Semester_ID + ',' + item.SC_FK_CourseID + ',' + item.CLS_ClassName"
                                    :label="item.CLS_ClassName + ' (' + item.SMT_Year + ')'"
                                    :value="item.PK_Semester_ID + ',' + item.SC_FK_CourseID + ',' + item.CLS_ClassName"
                                  >
                                  </el-option>
                                </el-select>
                              </div>
                              <div class="col-lg-12 divCopySelectStudent">
                                <label>{{ lang('Select Student To Copy') }}</label>
                                <el-select v-model="ddlCopyStudent" :placeholder="lang('Select Student')" class="pro-edt-select ddlCopyStudent">
                                  <el-option
                                    v-for="item in ddlCopyStudentList"
                                    :key="item.StudentID"
                                    :label="item.First_Name + item.Middle_Name + item.Last_Name"
                                    :value="item.StudentID"
                                  >
                                  </el-option>
                                </el-select>
                              </div>
                              <div class="col-lg-12" v-if="ddlCopyStudent !== '' && ddlCopyClass !== ''">
                                <el-button type="primary" class="mt-2 mb-2" @click="copyPlanner()">
                                  {{ lang('Copy') }}
                                </el-button>
                              </div>
                            </div>
                          </b-card-text></b-tab
                        >
                      </b-tabs>
                    </b-card>
                  </div>
                  <div class="col-lg-6">
                    <b-card no-body class="bcardStudentAssignStudent bcardStudentAssignStudent2">
                      <b-tabs pills card>
                        <b-tab
                          v-for="dsPassedTermInfoItem in passTermPlannerDetailsAll.dsPassedTermInfo.dsPassedTermInfo"
                          v-if="passTermPlannerDetailsAll.dsPassedTermInfo !== undefined"
                          :title="dsPassedTermInfoItem.TermNameTermYear"
                          :active="item.SemdID === dsPassedTermInfoItem.semdID"
                          ><b-card-text>
                            <div v-if="item.SemdID === dsPassedTermInfoItem.semdID">
                              <div class="empty-list_image" v-if="assignedPlannerList.length < 1">
                                <strong>{{ lang('No Data Found') }}...</strong>
                                <img src="../assets/notfound.png" />
                              </div>
                              <div v-if="assignedPlannerList.length > 0">
                                <div class="divAssignedPlannerListDesc">
                                  <div class="row">
                                    <div class="col-lg-3">
                                      <i class="material-icons">check_circle</i><label class="labelDisplayInline"> = {{ lang('Suggested') }}</label>
                                    </div>
                                    <!-- div class="col-lg-3">
                                                                        <i class="material-icons">style</i><label class="labelDisplayInline"> = {{lang('Master')}}</label>
                                                                    </div -->
                                    <div class="col-lg-3">
                                      <i class="material-icons">person_pin</i><label class="labelDisplayInline"> = {{ lang('Other') }}</label>
                                    </div>
                                    <div class="col-lg-3">
                                      <i class="material-icons">priority_high</i><label class="labelDisplayInline"> = {{ lang('Other Level') }}</label>
                                    </div>
                                    <div class="col-lg-3">
                                      <i class="material-icons">fiber_new</i><label class="labelDisplayInline"> = {{ lang('New') }}</label>
                                    </div>
                                  </div>
                                </div>
                                <div class="divSearchAssignedPlannerList filterArea">
                                  <div class="filterAreaDropDown">
                                    <el-select
                                      v-model="ddlSearchAssignedPlannerList"
                                      @change="filterAssignedPlannerList()"
                                      :placeholder="lang('Filter By')"
                                      class="pro-edt-select filterDDL"
                                    >
                                      <el-option v-for="item in ddlSearchAssignedPlannerListList" :key="item.Domain" :label="item.Domain" :value="item.Domain">
                                      </el-option>
                                    </el-select>
                                  </div>
                                  <div class="filterAreaInput">
                                    <input
                                      type="text"
                                      class="form-control inputKeySkillCLD"
                                      v-model="inputSearchAssignedPlannerList"
                                      :placeholder="lang('Search Indicator')"
                                      @change="filterAssignedPlannerList()"
                                    />
                                  </div>
                                </div>
                                <data-tables :data="filterAssignedPlannerList()" :pagination-props="{ pageSizes: [100, 200, 300] }">
                                  <el-table-column
                                    v-for="assignedPlannerInfo in assignedPlanner"
                                    :prop="assignedPlannerInfo.prop"
                                    :label="lang(assignedPlannerInfo.label)"
                                    :key="assignedPlannerInfo.prop"
                                    sortable="custom"
                                  >
                                  </el-table-column>
                                  <el-table-column label="" width="40px">
                                    <template slot-scope="scope">
                                      <i class="material-icons" v-if="scope.row.Type === 'Suggested'">check_circle</i>
                                      <i class="material-icons" v-if="scope.row.Type === 'Master'">style</i>
                                      <i class="material-icons" v-if="scope.row.Type === 'Other'">person_pin</i>
                                      <i class="material-icons" v-if="scope.row.Type === 'OtherLevelITL' || scope.row.Type === 'OtherLevelOther'"
                                        >priority_high</i
                                      >
                                      <i class="material-icons" v-if="scope.row.Type === 'Self'">fiber_new</i>
                                    </template>
                                  </el-table-column>
                                  <el-table-column label="" width="40px">
                                    <template slot-scope="scope">
                                      <i class="material-icons assignedPlannerDelete" v-if="scope.row.Mode !== 'BringForward'" @click="DeletePlanner(scope.row)"
                                        >delete</i
                                      >
                                      <i class="material-icons assignedPlannerDelete iconDisableColor" v-if="scope.row.Mode === 'BringForward'">delete</i>
                                    </template>
                                  </el-table-column>
                                  <el-table-column label="" width="80px">
                                    <template slot-scope="scope">
                                      <div class="grid-container">
                                        <div :class="{ 'grid-item-1': checkContain(scope.row.AssignedPassTerms, '0') }" class="grid-item">1</div>
                                        <div :class="{ 'grid-item-2': checkContain(scope.row.AssignedPassTerms, '1') }" class="grid-item">2</div>
                                        <div :class="{ 'grid-item-3': checkContain(scope.row.AssignedPassTerms, '2') }" class="grid-item">3</div>
                                        <div :class="{ 'grid-item-4': checkContain(scope.row.AssignedPassTerms, '3') }" class="grid-item">4</div>
                                      </div>
                                    </template>
                                  </el-table-column>
                                </data-tables>
                              </div>
                            </div>
                            <div v-if="item.SemdID !== dsPassedTermInfoItem.semdID">
                              <div class="empty-list_image" v-if="filterPassTermPlanner(dsPassedTermInfoItem.semdID).length < 1">
                                <strong>{{ lang('No Data Found') }}...</strong>
                                <img src="../assets/notfound.png" />
                              </div>
                              <div v-if="filterPassTermPlanner(dsPassedTermInfoItem.semdID).length > 0">
                                <data-tables :data="filterPassTermPlanner(dsPassedTermInfoItem.semdID)" :pagination-props="{ pageSizes: [100, 200, 300] }">
                                  <el-table-column
                                    v-for="passTermPlannerDetailsInfo in passTermPlannerDetails"
                                    :prop="passTermPlannerDetailsInfo.prop"
                                    :label="lang(passTermPlannerDetailsInfo.label)"
                                    :key="passTermPlannerDetailsInfo.prop"
                                    sortable="custom"
                                  >
                                  </el-table-column>
                                </data-tables>
                              </div>
                            </div> </b-card-text
                        ></b-tab>
                      </b-tabs>
                    </b-card>
                  </div>
                  <!--<div class="col-lg-12 divPlannerAssignStudentSaveButton" v-if="assignedPlannerList.length>0">-->
                  <div class="col-lg-12 divPlannerAssignStudentSaveButton">
                    <div class="row">
                      <div class="col-lg-12" v-if="needApprover">
                        <label>{{ lang('Comment for other level planner') }}</label>
                        <input type="text" class="form-control" v-model="inputCommentApprover" />
                      </div>
                      <div class="col-lg-12">
                        <el-button type="primary" class="mt-2 mb-2" @click="saveStudentPlanner()" id="btnSavePlanner">
                          {{ lang('Save') }}
                        </el-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <v-tour name="plannerTourName" :steps="plannerTour" :options="plannerTourOptions" :callbacks="plannerTourCallBacks">
      <template slot-scope="tour">
        <transition name="fade">
          <v-step
            v-if="tour.currentStep === index"
            v-for="(step, index) of tour.steps"
            :key="index"
            :step="step"
            :previous-step="tour.previousStep"
            :next-step="tour.nextStep"
            :stop="tour.stop"
            :is-first="tour.isFirst"
            :is-last="tour.isLast"
            :labels="tour.labels"
          >
            <template v-if="tour.currentStep === 0">
              <div slot="actions">
                <button class="v-step__button" @click="plannerTourNexPreviousStep(tour, 'Stop')">Skip</button>
                <button class="v-step__button" @click="plannerTourNexPreviousStep(tour, 'Next')">Next</button>
              </div>
            </template>
            <template v-if="tour.currentStep !== 0 && tour.currentStep + 1 !== tour.steps.length">
              <div slot="actions">
                <button class="v-step__button" @click="plannerTourNexPreviousStep(tour, 'Stop')">Skip</button>
                <button class="v-step__button" @click="plannerTourNexPreviousStep(tour, 'Previous')">Previous</button>
                <button class="v-step__button" @click="plannerTourNexPreviousStep(tour, 'Next')">Next</button>
              </div>
            </template>
            <template v-if="tour.currentStep + 1 === tour.steps.length">
              <div slot="actions">
                <button class="v-step__button" @click="plannerTourNexPreviousStep(tour, 'Stop')">Skip</button>
                <button class="v-step__button" @click="plannerTourNexPreviousStep(tour, 'Previous')">Previous</button>
              </div>
            </template>
          </v-step>
        </transition>
      </template>
    </v-tour>
  </div>
</template>

<script>
import DataSource from '../data/datasource'
import Cookies from 'js-cookie'
import { lang, selectedLocale } from '../locale/index'
import XLSX from 'xlsx'
import Vue from 'vue'
import VueTour from 'vue-tour'
require('vue-tour/dist/vue-tour.css')
Vue.use(VueTour)

export default {
  name: 'PlannerAssignStudent',
  props: ['passTourData'],
  data() {
    return {
      currentSchID: Cookies.get('schoolSession'),
      currentUserType: Cookies.get('userTypeSession'),
      isLoading: false,
      eltabActive: 'etpStudentList',

      ddlSearchMasterPlannerList: '',
      ddlSearchMasterPlannerListList: [],
      inputSearchMasterPlannerList: '',
      ddlSearchAssignedPlannerList: '',
      ddlSearchAssignedPlannerListList: [],
      inputSearchAssignedPlannerList: '',
      ddlSearchMasterPlannerOther: '',
      ddlSearchMasterPlannerOtherList: [],
      inputSearchMasterPlannerOther: '',
      ddlSearchMasterOtherLevelPlannerList: '',
      ddlSearchMasterOtherLevelPlannerListList: [],
      inputSearchMasterOtherLevelPlannerList: '',
      ddlSearchMasterOtherLevelPlannerListType: '',
      ddlSearchMasterOtherLevelPlannerListTypeList: ['', 'Learning Goals', 'Other'],
      ddlSearchMasterOtherLevelPlannerListLevel: '',
      ddlSearchMasterOtherLevelPlannerListLevelList: [],

      multipleStudentSelection: [],
      ddlClassListAll: [],
      ddlClassList: [],
      ddlClass: '',
      ddlSemesterDetailsList: [],
      ddlSemesterDetails: '',
      tabDetails: [],

      needApprover: false,
      inputCommentApprover: '',

      studentPlannerSummaryInt: [],
      studentPlannerSummary: [
        {
          prop: 'Index_No',
          label: 'Student ID',
        },
        {
          prop: 'StudentFullName',
          label: 'Student Name',
        },
        {
          prop: 'NumberOfPlannerDetialsAssigned',
          label: 'Number of Learning Goals Assigned',
        },
        {
          prop: 'Status',
          label: 'Status',
        },
      ],

      masterPlannerList: [],
      // masterPlanner: [{
      //     prop: 'Domain',
      //     label: "Domain"
      // }, {
      //     prop: "Goals",
      //     label: "Goals"
      // }, {
      //     prop: "Indicator",
      //     label: "Indicator"
      // }],
      masterPlanner: [],

      assignedPlannerListInDB: [],
      assignedPlannerList: [],
      // assignedPlanner: [{
      //     prop: 'Domain',
      //     label: "Domain"
      // }, {
      //     prop: "Goals",
      //     label: "Goals"
      // }, {
      //     prop: "Indicator",
      //     label: "Indicator"
      // }],
      assignedPlanner: [],

      masterPlannerOtherList: [],
      // masterPlannerOther: [{
      //     prop: 'Domain',
      //     label: "Domain"
      // }, {
      //     prop: "Goals",
      //     label: "Goals"
      // }, {
      //     prop: "Indicator",
      //     label: "Indicator"
      // }],
      masterPlannerOther: [],

      masterPlannerListOtherLevel: [],
      // masterPlannerOtherLevel: [{
      //     prop: 'Domain',
      //     label: "Domain"
      // }, {
      //     prop: "Goals",
      //     label: "Goals"
      // }, {
      //     prop: "Indicator",
      //     label: "Indicator"
      // }],
      masterPlannerOtherLevel: [],

      passTermPlannerDetailsAll: [],
      // passTermPlannerDetails: [{
      //     prop: 'Domain',
      //     label: "Domain"
      // }, {
      //     prop: "Goals",
      //     label: "Goals"
      // }, {
      //     prop: "Indicator",
      //     label: "Indicator"
      // }],
      passTermPlannerDetails: [],

      ddlDomainList: [],
      dllDomain: '',
      ddlGoalsList: [],
      ddlGoals: '',
      indicator: '',

      ddlClassListNoFilter: [],
      ddlCopyClassList: [],
      ddlCopyClass: '',
      ddlCopyStudentList: [],
      ddlCopyStudent: '',

      lblDomain: '',
      lblGoals: '',
      lblIndicator: '',

      //vue tour
      tourRunning: false,
      selectStudentTour: false,

      plannerTourOptions: {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: 'Skip tour',
          buttonPrevious: 'Previous',
          buttonNext: 'Next',
          buttonStop: 'Finish',
        },
      },
      plannerTourCallBacks: {
        // onPreviousStep: this.studentPageUpdateLevelClassVueTourCallBacksPreviousSteps,
        // onNextStep: this.studentPageUpdateLevelClassVueTourCallBacksNextSteps
      },
      plannerTour: [
        //Level Tab
        {
          target: '#ddlClass',
          content: `<div class="studentPageTourDiv">Step 1 / 8 <br>Select Class</div>`,
          params: {
            placement: 'top',
          },
        },
        {
          target: '#ddlSemesterDetails',
          content: `<div class="studentPageTourDiv">Step 2 / 8 <br>Select Term</div>`,
          params: {
            placement: 'top',
          },
        },
        {
          target: '#divDtudentPlannerSummary',
          content: `<div class="studentPageTourDiv">Step 3 / 8 <br>Tick box to select multiple students<br>Action column to assign single student<br>Progress column to view student's progress</div>`,
          params: {
            placement: 'top',
          },
        },
        {
          target: '#btnAssignMultipleStudents',
          content: `<div class="studentPageTourDiv">Step 4 / 8 <br>Click Assign Multiple Students button to assign multiple students</div>`,
          params: {
            placement: 'top',
          },
        },
        {
          target: '#btnDownload',
          content: `<div class="studentPageTourDiv">Step 5 / 8 <br>Click Download button to download the Goals have been assign to the students</div>`,
          params: {
            placement: 'top',
          },
        },
        {
          target: '#assigningStudentName',
          content: `<div class="studentPageTourDiv">Step 6 / 8 <br>Left section is master list<br>Right section is assigned list, if assign as multiple students, will not show any assigned planner</div>`,
          params: {
            placement: 'top',
          },
        },
        {
          target: '#btnCopy___BV_tab_button__',
          content: `<div class="studentPageTourDiv">Step 7 / 8 <br>Copy from other student</div>`,
          params: {
            placement: 'top',
          },
        },
        {
          target: '#btnSavePlanner',
          content: `<div class="studentPageTourDiv">Step 8 / 8 <br>Save Planner<br>If save as multiple students, will only add on new to those students not saved the particular Goals</div>`,
          params: {
            placement: 'top',
          },
        },
      ],
      //vue tour
    }
  },
  async created() {
    await this.bindClasses()
    await this.bindClassesNoFilter()
  },
  async mounted() {
    if (this.passTourData === 'planner') {
      this.plannerTourStart()
    }
  },
  methods: {
    lang,
    selectedLocale,
    async bindClasses() {
      try {
        const response = await DataSource.shared.getAttendanceClass()
        if (response) {
          // this.class = response.Table;
          // this.class.forEach(m => {
          //     this.ddlClassList.push(m);
          // });

          this.class = response.Table
          this.class.forEach(m => {
            this.ddlClassListAll.push(m)
          })

          response.Table.forEach(m => {
            let check = this.ddlClassList.filter(
              m2 => m2.CLS_ClassName.trim() === m.CLS_ClassName.trim() && m2.PK_Semester_ID === m.PK_Semester_ID && m.SC_FK_CourseID === m2.SC_FK_CourseID,
            )

            if (check.length < 1) {
              let temp = {
                CLS_ClassName: m.CLS_ClassName.trim(),
                PK_Semester_ID: m.PK_Semester_ID,
                SC_FK_CourseID: m.SC_FK_CourseID,
                SMT_Year: m.SMT_Year,
              }

              this.ddlClassList.push(temp)
            }
          })
        }
      } catch (e) {
        this.results = e
      }
    },
    async bindClassesNoFilter() {
      try {
        const response = await DataSource.shared.getAttendanceClassWithMode('CancalFilterClassByType')
        if (response) {
          this.class = response.Table
          this.class.forEach(m => {
            this.ddlClassListNoFilter.push(m)
          })
        }
      } catch (e) {
        this.results = e
      }
    },
    async bindSemesterDetails() {
      try {
        let ddlClassObj = this.ddlClass.split(',')

        const response = await DataSource.shared.getSemesterTermDetailsBySemID(ddlClassObj[0], '', 'Active')
        if (response) {
          this.class = response.Table
          this.class.forEach(m => {
            this.ddlSemesterDetailsList.push(m)
          })
        }
      } catch (e) {
        this.results = e
      }
    },
    async LoadClassList(mode) {
      try {
        if (this.ddlClass === '' || this.ddlSemesterDetails === '') {
          this.$notify.error({
            title: 'Error',
            message: 'Please select Class & Term...',
          })
        } else {
          if (mode !== 'copy') {
            this.isLoading = true
          }

          if (mode !== 'AfterSave' && mode !== 'copy') {
            this.studentPlannerSummaryInt = []
            this.tabDetails = []
          }

          let classDetails = ''
          if (mode === 'copy') {
            classDetails = this.ddlCopyClass + ',' + this.ddlSemesterDetails
          } else {
            classDetails = this.ddlClass + ',' + this.ddlSemesterDetails
          }

          const response = await DataSource.shared.getPlannerAssignedStudentSummaryByClassSemester(classDetails)
          if (response) {
            if (response.code === '2') {
              console.log('getPlannerAssignedStudentSummaryByClassSemester no record')
            } else if (response.code === '88') {
              window.location.replace('/')
            } else if (response.code === '99') {
              console.log('getPlannerAssignedStudentSummaryByClassSemester error')
            } else {
              if (mode === 'copy') {
                this.ddlCopyStudentList = response.Table
              } else {
                this.studentPlannerSummaryInt = response.Table
              }
            }
          }

          this.isLoading = false
        }
      } catch (e) {
        this.results = e
      }
    },
    async getPlannerSuggested(SchID, SemID, CrsID) {
      try {
        let result = []

        const response = await DataSource.shared.getPlannerAssignedDetialsToSchool(SchID, SemID, CrsID, '')
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            console.log('getPlannerAssignedDetialsToSchool error')
          } else if (response.code === '2') {
            console.log('getPlannerAssignedDetialsToSchool no record')
          } else {
            result = response.Table
          }
        }

        return result
      } catch (e) {
        this.results = e
      }
    },
    async getPlannerMaster(LevelType) {
      try {
        let result = []

        const response = await DataSource.shared.getPlannerMaster(LevelType, '', '', '')
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            console.log('getPlannerMaster error')
          } else if (response.code === '2') {
            console.log('getPlannerMaster no record')
          } else {
            result = response.Table
          }
        }

        return result
      } catch (e) {
        this.results = e
      }
    },
    async getPlannerMasterOtherLevel(LevelType) {
      try {
        let result = []

        const response = await DataSource.shared.getPlannerMaster(LevelType, '', 'AllLevelBySchoolWithNotEqualLevel')
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            console.log('getPlannerMasterOtherLevel error')
          } else if (response.code === '2') {
            console.log('getPlannerMasterOtherLevel no record')
          } else {
            result = response.Table
          }
        }

        return result
      } catch (e) {
        this.results = e
      }
    },
    async getStudentPlannerDetails(StudentID, SemID, CrsID, SemdID) {
      try {
        let result = []

        const response = await DataSource.shared.getPlannerAssignedStudentDetails('Active', StudentID, SemID, CrsID, SemdID, '')
        if (response) {
          if (response.code === '2') {
            console.log('getPlannerAssignedStudentDetails no record')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            console.log('getPlannerAssignedStudentDetails error')
          } else {
            result = response.Table
          }
        }

        return result
      } catch (e) {
        this.results = e
      }
    },
    async getPlannerAssignedStudentDetailsByAcademicYear(StudentID, SemID) {
      try {
        let result = []

        const response = await DataSource.shared.getPlannerAssignedStudentDetailsByAcademicYear(StudentID, SemID)
        if (response) {
          if (response.code === '2') {
            console.log('getPlannerAssignedStudentDetailsForPassedTerms no record')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            console.log('getPlannerAssignedStudentDetailsForPassedTerms error')
          } else {
            result = response
          }
        }

        return result
      } catch (e) {
        this.results = e
      }
    },
    async changeTab(tabName) {
      if (this.tourRunning) {
        if (this.$tours['plannerTourName'].currentStep > 4) {
          this.tourRunning = false
          this.$tours['plannerTourName'].stop()
        }
      }

      //clear multiple students selection
      this.multipleStudentSelection = []
      //clear multiple students selection

      //clear approver
      this.needApprover = false
      this.inputCommentApprover = ''
      //clear approver

      //clear the dataset
      this.assignedPlannerListInDB = []

      this.masterPlannerList = []
      this.masterPlannerOtherList = []
      this.assignedPlannerList = []
      this.masterPlannerListOtherLevel = []
      this.passTermPlannerDetailsAll = []
      this.ddlDomainList = []
      this.dllDomain = ''
      this.ddlGoalsList = []
      this.ddlGoals = ''
      this.indicator = ''
      this.ddlCopyClassList = []
      this.ddlCopyClass = ''
      this.ddlCopyStudentList = []
      this.ddlCopyStudent = ''
      let suggestedList = []
      let masterList = []
      let assignedList = []
      let masterListOtherLevel = []
      let passTermDetailsAll = []

      let tempPassTermDetailsAll = {
        dsPassedTermInfo: [{ dsPassedTermInfo: [] }],
        dsPlannerAssignedPassedTermDetails: [{ dsPlannerAssignedPassedTermDetails: [] }],
      }
      this.passTermPlannerDetailsAll = tempPassTermDetailsAll
      //clear the dataset

      //data table naming
      this.masterPlanner = []
      this.assignedPlanner = []
      this.masterPlannerOther = []
      this.masterPlannerOtherLevel = []
      this.passTermPlannerDetails = []
      //data table naming

      this.isLoading = true

      let seletedTabName = ''

      if (tabName === '') {
        seletedTabName = this.eltabActive
      } else {
        seletedTabName = tabName
      }

      if (seletedTabName !== '') {
        let checkIfExistingTab = this.tabDetails.filter(m => m.TabName === seletedTabName)

        if (checkIfExistingTab.length > 0) {
          /*#region data table naming*/
          let IB = false

          if (Cookies.get('schoolSession') === 'SCH201400000553' || Cookies.get('schoolSession') === 'SCH201400000471') {
            if (checkIfExistingTab[0].LevelType === 'N2' || checkIfExistingTab[0].LevelType === 'K1' || checkIfExistingTab[0].LevelType === 'K2') {
              IB = true
            } else if (selectedLocale() === 'CH') {
              IB = true
            }
          }

          if (Cookies.get('schoolSession') === 'SCH201400000553' || Cookies.get('schoolSession') === 'SCH201400000471') {
            if (checkIfExistingTab[0].LevelType === 'N2' || checkIfExistingTab[0].LevelType === 'K1' || checkIfExistingTab[0].LevelType === 'K2') {
              this.lblDomain = 'Subject Focus'
              this.lblGoals = 'Subject Area'
              this.lblIndicator = 'Learning Goals'

              this.masterPlanner = [
                {
                  prop: 'Domain',
                  label: 'Subject Focus',
                },
                {
                  prop: 'Goals',
                  label: 'Subject Area',
                },
                {
                  prop: 'Indicator',
                  label: 'Learning Goals',
                },
              ]

              this.assignedPlanner = [
                {
                  prop: 'Domain',
                  label: 'Subject Focus',
                },
                {
                  prop: 'Goals',
                  label: 'Subject Area',
                },
                {
                  prop: 'Indicator',
                  label: 'Learning Goals',
                },
              ]

              this.masterPlannerOther = [
                {
                  prop: 'Domain',
                  label: 'Subject Focus',
                },
                {
                  prop: 'Goals',
                  label: 'Subject Area',
                },
                {
                  prop: 'Indicator',
                  label: 'Learning Goals',
                },
              ]

              this.masterPlannerOtherLevel = [
                {
                  prop: 'Domain',
                  label: 'Subject Focus',
                },
                {
                  prop: 'Goals',
                  label: 'Subject Area',
                },
                {
                  prop: 'Indicator',
                  label: 'Learning Goals',
                },
              ]

              this.passTermPlannerDetails = [
                {
                  prop: 'Domain',
                  label: 'Subject Focus',
                },
                {
                  prop: 'Goals',
                  label: 'Subject Area',
                },
                {
                  prop: 'Indicator',
                  label: 'Learning Goals',
                },
              ]
            } else if (checkIfExistingTab[0].LevelType === 'PN' || checkIfExistingTab[0].LevelType === 'N1') {
              this.lblDomain = 'Areas of Learning'
              this.lblGoals = 'Learning Focus'
              this.lblIndicator = 'Learning Goals'

              this.masterPlanner = [
                {
                  prop: 'Domain',
                  label: 'Areas of Learning',
                },
                {
                  prop: 'Goals',
                  label: 'Learning Focus',
                },
                {
                  prop: 'Indicator',
                  label: 'Learning Goals',
                },
              ]

              this.assignedPlanner = [
                {
                  prop: 'Domain',
                  label: 'Areas of Learning',
                },
                {
                  prop: 'Goals',
                  label: 'Learning Focus',
                },
                {
                  prop: 'Indicator',
                  label: 'Learning Goals',
                },
              ]

              this.masterPlannerOther = [
                {
                  prop: 'Domain',
                  label: 'Areas of Learning',
                },
                {
                  prop: 'Goals',
                  label: 'Learning Focus',
                },
                {
                  prop: 'Indicator',
                  label: 'Learning Goals',
                },
              ]

              this.masterPlannerOtherLevel = [
                {
                  prop: 'Domain',
                  label: 'Areas of Learning',
                },
                {
                  prop: 'Goals',
                  label: 'Learning Focus',
                },
                {
                  prop: 'Indicator',
                  label: 'Learning Goals',
                },
              ]

              this.passTermPlannerDetails = [
                {
                  prop: 'Domain',
                  label: 'SAreas of Learning',
                },
                {
                  prop: 'Goals',
                  label: 'Learning Focus',
                },
                {
                  prop: 'Indicator',
                  label: 'Learning Goals',
                },
              ]
            }
          } else {
            this.lblDomain = 'Domain'
            this.lblGoals = 'Goals'
            this.lblIndicator = 'Indicator'

            this.masterPlanner = [
              {
                prop: 'Domain',
                label: 'Domain',
              },
              {
                prop: 'Goals',
                label: 'Goals',
              },
              {
                prop: 'Indicator',
                label: 'Indicator',
              },
            ]

            this.assignedPlanner = [
              {
                prop: 'Domain',
                label: 'Domain',
              },
              {
                prop: 'Goals',
                label: 'Goals',
              },
              {
                prop: 'Indicator',
                label: 'Indicator',
              },
            ]

            this.masterPlannerOther = [
              {
                prop: 'Domain',
                label: 'Domain',
              },
              {
                prop: 'Goals',
                label: 'Goals',
              },
              {
                prop: 'Indicator',
                label: 'Indicator',
              },
            ]

            this.masterPlannerOtherLevel = [
              {
                prop: 'Domain',
                label: 'Domain',
              },
              {
                prop: 'Goals',
                label: 'Goals',
              },
              {
                prop: 'Indicator',
                label: 'Indicator',
              },
            ]

            this.passTermPlannerDetails = [
              {
                prop: 'Domain',
                label: 'Domain',
              },
              {
                prop: 'Goals',
                label: 'Goals',
              },
              {
                prop: 'Indicator',
                label: 'Indicator',
              },
            ]
          }
          /*#endregion*/

          /*#region get assigned list by passed term*/
          passTermDetailsAll = await this.getPlannerAssignedStudentDetailsByAcademicYear(checkIfExistingTab[0].StudentID, checkIfExistingTab[0].SemID)
          if (passTermDetailsAll.length < 1) {
            let tempPassTermDetailsAll = {
              dsPassedTermInfo: [{ dsPassedTermInfo: [] }],
              dsPlannerAssignedPassedTermDetails: [{ dsPlannerAssignedPassedTermDetails: [] }],
            }
            this.passTermPlannerDetailsAll = tempPassTermDetailsAll
          } else {
            this.passTermPlannerDetailsAll = passTermDetailsAll
          }
          /*#endregion*/

          /*#region get suggested list*/
          suggestedList = await this.getPlannerSuggested(this.currentSchID, checkIfExistingTab[0].SemID, checkIfExistingTab[0].CrsID)

          suggestedList.forEach(m => {
            let indexForPassTerms = this.checkPassedTermAssigned(m.PlnMasDomain, m.PlnMasGoalsITL, m.PlnMasIndicator, checkIfExistingTab[0].SemdID, '')

            let tempSuggestedList = {
              Domain: m.PlnMasDomain,
              Goals: m.PlnMasGoalsITL,
              Indicator: m.PlnMasIndicator,
              Type: 'Suggested',
              Active: 'True',
              AssignedPassTerms: indexForPassTerms,
            }
            if (m.PlnMasLang === selectedLocale() && ((IB && m.PlnMasCourseType === 'IB') || (!IB && m.PlnMasCourseType === 'NON IB'))) {
              this.masterPlannerList.push(tempSuggestedList)
            }
          })
          /*#endregion*/

          /*#region get master list*/
          masterList = await this.getPlannerMaster(checkIfExistingTab[0].LevelType)

          masterList.forEach(m => {
            //check if suggested list added before
            let checkIfSuggestedListInMasterList = this.masterPlannerList.filter(
              m2 => m2.Domain === m.PlnMasDomain && m2.Goals === m.PlnMasGoalsITL && m2.Indicator === m.PlnMasIndicator,
            )

            if (checkIfSuggestedListInMasterList.length < 1) {
              let indexForPassTerms = this.checkPassedTermAssigned(m.PlnMasDomain, m.PlnMasGoalsITL, m.PlnMasIndicator, checkIfExistingTab[0].SemdID, '')

              if (m.PlnMasType === 'ITL') {
                let tempMasterList = {
                  Domain: m.PlnMasDomain,
                  Goals: m.PlnMasGoalsITL,
                  Indicator: m.PlnMasIndicator,
                  Type: 'Master',
                  Active: 'True',
                  AssignedPassTerms: indexForPassTerms,
                }
                if (m.PlnMasLang === selectedLocale() && ((IB && m.PlnMasCourseType === 'IB') || (!IB && m.PlnMasCourseType === 'NON IB'))) {
                  this.masterPlannerList.push(tempMasterList)
                }
              } else {
                let tempMasterList = {
                  Domain: m.PlnMasDomain,
                  Goals: m.PlnMasGoalsITL,
                  Indicator: m.PlnMasIndicator,
                  Type: 'Other',
                  Active: 'True',
                  AssignedPassTerms: indexForPassTerms,
                }
                if (m.PlnMasLang === selectedLocale() && ((IB && m.PlnMasCourseType === 'IB') || (!IB && m.PlnMasCourseType === 'NON IB'))) {
                  this.masterPlannerOtherList.push(tempMasterList)
                }
              }
            }
          })
          /*#endregion*/

          /*#region get master list of other level*/
          masterListOtherLevel = await this.getPlannerMasterOtherLevel(checkIfExistingTab[0].LevelType)

          masterListOtherLevel.forEach(m => {
            let indexForPassTerms = this.checkPassedTermAssigned(m.PlnMasDomain, m.PlnMasGoalsITL, m.PlnMasIndicator, checkIfExistingTab[0].SemdID, '')

            if (m.PlnMasType === 'ITL') {
              let tempMasterListOtherLevel = {
                Domain: m.PlnMasDomain,
                Goals: m.PlnMasGoalsITL,
                Indicator: m.PlnMasIndicator,
                Type: 'OtherLevelITL',
                Active: 'True',
                AssignedPassTerms: indexForPassTerms,
                Level: m.PlnMasLevel,
              }
              if (m.PlnMasLang === selectedLocale() && ((IB && m.PlnMasCourseType === 'IB') || (!IB && m.PlnMasCourseType === 'NON IB'))) {
                this.masterPlannerListOtherLevel.push(tempMasterListOtherLevel)
              }
            } else {
              let tempMasterListOtherLevel = {
                Domain: m.PlnMasDomain,
                Goals: m.PlnMasGoalsITL,
                Indicator: m.PlnMasIndicator,
                Type: 'OtherLevelOther',
                Active: 'True',
                AssignedPassTerms: indexForPassTerms,
                Level: m.PlnMasLevel,
              }
              if (m.PlnMasLang === selectedLocale() && ((IB && m.PlnMasCourseType === 'IB') || (!IB && m.PlnMasCourseType === 'NON IB'))) {
                this.masterPlannerListOtherLevel.push(tempMasterListOtherLevel)
              }
            }
          })
          /*#endregion*/

          /*#region get assigned list */
          assignedList = await this.getStudentPlannerDetails(
            checkIfExistingTab[0].StudentID,
            checkIfExistingTab[0].SemID,
            checkIfExistingTab[0].CrsID,
            checkIfExistingTab[0].SemdID,
          )
          this.assignedPlannerListInDB = assignedList

          assignedList.forEach(m => {
            //check if master or suggested list or other list, if yes, get the type and set active to false in master
            let checkIfMasterListInAssignedList = this.masterPlannerList.filter(
              m2 => m2.Domain === m.PlnStaDomain && m2.Goals === m.PlnStaGoals && m2.Indicator === m.PlnStaIndicator,
            )
            let checkIfMasterOtherListInAssignedList = this.masterPlannerOtherList.filter(
              m3 => m3.Domain === m.PlnStaDomain && m3.Goals === m.PlnStaGoals && m3.Indicator === m.PlnStaIndicator,
            )
            let checkIfMasterListOtherLevelInAssignedList = this.masterPlannerListOtherLevel.filter(
              m6 => m6.Domain === m.PlnStaDomain && m6.Goals === m.PlnStaGoals && m6.Indicator === m.PlnStaIndicator,
            )

            let indexForPassTerms = this.checkPassedTermAssigned(m.PlnStaDomain, m.PlnStaGoals, m.PlnStaIndicator, checkIfExistingTab[0].SemdID, 'Yes')

            if (checkIfMasterListInAssignedList.length > 0) {
              this.masterPlannerList = this.masterPlannerList.map(m4 => {
                if (m4.Domain === m.PlnStaDomain && m4.Goals === m.PlnStaGoals && m4.Indicator === m.PlnStaIndicator) {
                  m4.Active = 'False'
                }

                return m4
              })

              let tempAssignedList = {
                Domain: m.PlnStaDomain,
                Goals: m.PlnStaGoals,
                Indicator: m.PlnStaIndicator,
                Type: checkIfMasterListInAssignedList[0].Type,
                AssignedPassTerms: indexForPassTerms,
                Mode: m.PlnMode,
              }

              //check owner only
              //if(m.PlnStaCreatedBy == Cookies.get('userIDSession'))
              //{
              this.assignedPlannerList.push(tempAssignedList)
              //}
            } else if (checkIfMasterOtherListInAssignedList.length > 0) {
              this.masterPlannerOtherList = this.masterPlannerOtherList.map(m5 => {
                if (m5.Domain === m.PlnStaDomain && m5.Goals === m.PlnStaGoals && m5.Indicator === m.PlnStaIndicator) {
                  m5.Active = 'False'
                }

                return m5
              })

              let tempAssignedList = {
                Domain: m.PlnStaDomain,
                Goals: m.PlnStaGoals,
                Indicator: m.PlnStaIndicator,
                Type: checkIfMasterOtherListInAssignedList[0].Type,
                AssignedPassTerms: indexForPassTerms,
                Mode: m.PlnMode,
              }
              //check owner only
              //if(m.PlnStaCreatedBy == Cookies.get('userIDSession'))
              //{
              this.assignedPlannerList.push(tempAssignedList)
              //}
            } else if (checkIfMasterListOtherLevelInAssignedList.length > 0) {
              this.masterPlannerListOtherLevel = this.masterPlannerListOtherLevel.map(m7 => {
                if (m7.Domain === m.PlnStaDomain && m7.Goals === m.PlnStaGoals && m7.Indicator === m.PlnStaIndicator) {
                  m7.Active = 'False'
                }

                return m7
              })

              let tempAssignedList = {
                Domain: m.PlnStaDomain,
                Goals: m.PlnStaGoals,
                Indicator: m.PlnStaIndicator,
                Type: checkIfMasterListOtherLevelInAssignedList[0].Type,
                AssignedPassTerms: indexForPassTerms,
                Mode: m.PlnMode,
              }
              //check owner only
              //if(m.PlnStaCreatedBy == Cookies.get('userIDSession'))
              //{
              this.assignedPlannerList.push(tempAssignedList)
              //}
            } else {
              let tempAssignedList = {
                Domain: m.PlnStaDomain,
                Goals: m.PlnStaGoals,
                Indicator: m.PlnStaIndicator,
                Type: 'Self',
                AssignedPassTerms: indexForPassTerms,
                Mode: m.PlnMode,
              }
              //check owner only
              //if(m.PlnStaCreatedBy == Cookies.get('userIDSession'))
              //{
              this.assignedPlannerList.push(tempAssignedList)
              //}
            }
          })
          /*#endregion*/

          /*#region domain thingy*/
          //get filter group by domain
          this.getGroupByDomainList('MasterList')
          this.getGroupByDomainList('MasterOtherList')
          this.getGroupByDomainList('AssignedList')
          this.getGroupByDomainList('MasterListOtherLevel')
          //get filter group by domain

          //get filter group by level
          this.getGroupByLevelList('MasterListOtherLevel')
          //get filter group by level

          //get distinct master domain dropdown list
          this.masterPlannerList.forEach(m => {
            let checkIfDdlDomainListExisting = this.ddlDomainList.filter(m2 => m2.Domain === m.Domain)

            if (checkIfDdlDomainListExisting.length < 1) {
              let tempDdlDomainList = {
                Domain: m.Domain,
              }

              this.ddlDomainList.push(tempDdlDomainList)
            }
          })
          //get distinct master domain dropdown list
          /*#endregion*/

          /*#region get copy class*/
          if (
            this.currentUserType === 'Parent Liaison' ||
            this.currentUserType === 'Admin Executive' ||
            this.currentUserType === 'Pedagogy' ||
            this.currentUserType === 'Principal' ||
            this.currentUserType === 'Course Leader'
          ) {
            this.ddlClassListNoFilter.forEach(m => {
              if (m.CLS_FK_Semester_ID === checkIfExistingTab[0].SemID && m.CLS_FK_Course_ID === checkIfExistingTab[0].CrsID) {
                let checkTempCopyClassList = this.ddlCopyClassList.filter(
                  m2 => m2.CLS_ClassName.trim() === m.CLS_ClassName.trim() && m2.PK_Semester_ID === m.PK_Semester_ID && m.SC_FK_CourseID === m2.SC_FK_CourseID,
                )

                if (checkTempCopyClassList.length < 1) {
                  let tempCopyClassList = {
                    CLS_ClassName: m.CLS_ClassName.trim(),
                    PK_Semester_ID: m.PK_Semester_ID,
                    SC_FK_CourseID: m.SC_FK_CourseID,
                    SMT_Year: m.SMT_Year,
                  }

                  this.ddlCopyClassList.push(tempCopyClassList)
                }
              }
            })
          } else {
            this.ddlClassListAll.forEach(m => {
              if (m.CLS_FK_Semester_ID === checkIfExistingTab[0].SemID && m.CLS_FK_Course_ID === checkIfExistingTab[0].CrsID) {
                let checkTempCopyClassList = this.ddlCopyClassList.filter(
                  m2 => m2.CLS_ClassName.trim() === m.CLS_ClassName.trim() && m2.PK_Semester_ID === m.PK_Semester_ID && m.SC_FK_CourseID === m2.SC_FK_CourseID,
                )

                if (checkTempCopyClassList.length < 1) {
                  let tempCopyClassList = {
                    CLS_ClassName: m.CLS_ClassName.trim(),
                    PK_Semester_ID: m.PK_Semester_ID,
                    SC_FK_CourseID: m.SC_FK_CourseID,
                    SMT_Year: m.SMT_Year,
                  }

                  this.ddlCopyClassList.push(tempCopyClassList)
                }
              }
            })
          }
          /*#endregion*/
        }
      }

      this.isLoading = false
    },
    async saveStudentPlanner() {
      try {
        if (this.needApprover === true && this.inputCommentApprover === '') {
          this.$notify({
            title: 'Required',
            message: 'Approver Comment Required...',
          })
        } else {
          this.$vs.loading()

          let saveStudentPlannerObj = {}
          let saveStudentPlannerDetials = []
          let saveStudentID = []
          let getExistingTabInfo = this.tabDetails.filter(m => m.TabName === this.eltabActive)

          //details
          this.assignedPlannerList.forEach(item => {
            let tempSaveStudentPlannerDetials = {
              Domain: item.Domain,
              Goals: item.Goals,
              Indicator: item.Indicator,
              Type: item.Type,
            }

            saveStudentPlannerDetials.push(tempSaveStudentPlannerDetials)
          })
          //details

          //student id
          let splitStudentID = getExistingTabInfo[0].StudentID.split(',')

          splitStudentID.forEach(item => {
            let tempsaveStudentID = {
              StudentID: item,
            }

            saveStudentID.push(tempsaveStudentID)
          })
          //student id

          //final obj
          saveStudentPlannerObj = {
            StudentID: saveStudentID,
            SemID: getExistingTabInfo[0].SemID,
            CrsID: getExistingTabInfo[0].CrsID,
            levelType: getExistingTabInfo[0].LevelType,
            SemdID: getExistingTabInfo[0].SemdID,
            Details: saveStudentPlannerDetials,
          }

          // saveStudentPlannerObj.push(tempSaveStudentPlannerObj);
          //final obj

          const response = await DataSource.shared.savePlannerAssignStudent(JSON.stringify(saveStudentPlannerObj), this.inputCommentApprover)
          // const response = await DataSource.shared.savePlannerAssignStudent(encodeURI(JSON.stringify(saveStudentPlannerObj)), this.inputCommentApprover);
          if (response) {
            if (response.code === '88') {
              window.location.replace('/')
            } else if (response.code === '99') {
              this.$notify.error({
                title: 'Error',
                message: 'Save Planner Assigned Student Details: ERROR!!',
              })
            } else {
              this.$notify({
                title: 'Successfully',
                message: 'Successfully Save...',
              })

              if (this.needApprover === true && this.inputCommentApprover !== '') {
                this.handleTabsEdit(this.eltabActive, 'remove')
              } else {
                this.changeTab('')
              }
            }
          }

          this.LoadClassList('AfterSave')

          this.$vs.loading.close()
        }
      } catch (e) {
        this.results = e
      }
    },
    async cancelPendingApprover(value) {
      try {
        this.$vs.loading()

        const response = await DataSource.shared.deletePlannerAssignStudentPendingApprover(value.ApproverID)
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            this.$notify.error({
              title: 'Error',
              message: 'Delete Planner Assign Student Pending Approver: ERROR!!',
            })
          } else {
            this.$notify({
              title: 'Successfully',
              message: 'Successfully Deleted...',
            })
          }
        }

        this.LoadClassList('AfterSave')

        this.$vs.loading.close()
      } catch (e) {
        this.results = e
      }
    },
    async downloadPlanner() {
      try {
        this.$vs.loading()

        let final = []

        this.multipleStudentSelection.forEach(item => {
          let temp = {
            CrsID: item.CrsID,
            SemID: item.SemID,
            SemdID: this.ddlSemesterDetails,
            StudentID: item.StudentID,
          }

          final.push(temp)
        })

        const response = await DataSource.shared.donwloadPlannerAssignedStudent(JSON.stringify(final))
        if (response) {
          if (response.code === '2') {
            this.$notify({
              title: 'No Record',
              message: 'No Record Found...',
            })
          } else if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            console.log('Donwload Planner Assigned Student: Error')
          } else {
            var wb = XLSX.utils.book_new() // make Workbook of Excel

            this.multipleStudentSelection.forEach(item => {
              let currentStudentList = response.Table.filter(data => data.Student_ID === item.StudentID)

              let currentStudentListFinal = []

              if (currentStudentList.length > 0) {
                let studentName = currentStudentList[0].Full_Name
                if (currentStudentList[0].Middle_name && currentStudentList[0].Middle_name !== '') {
                  studentName += ' ' + currentStudentList[0].Middle_name
                }
                studentName += ' ' + currentStudentList[0].Last_name

                currentStudentList.forEach(value => {
                  let temp = {
                    StudentID: value.Index_No,
                    Name: studentName,
                    Domain: value.PlnStaDomain,
                    Goals: value.PlnStaGoals,
                    Indicator: value.PlnStaIndicator,
                  }

                  currentStudentListFinal.push(temp)
                })

                var sheet1WS = XLSX.utils.json_to_sheet(currentStudentListFinal)
                XLSX.utils.book_append_sheet(wb, sheet1WS, studentName) // sheetAName is name of Worksheet
              }
            })

            XLSX.writeFile(wb, 'Planner Assigned List.xlsx') // name of the file is 'book.xlsx'
          }
        }

        this.$vs.loading.close()
      } catch (e) {
        this.results = e
      }
    },
    ClassChange() {
      this.ddlSemesterDetailsList = []
      this.ddlSemesterDetails = ''

      this.studentPlannerSummaryInt = []
      this.tabDetails = []

      this.bindSemesterDetails()
    },
    assignStudent(value) {
      let checkIfExistingTab = this.tabDetails.filter(m => m.TabName === 'etp' + value.StudentID)

      if (checkIfExistingTab.length > 0) {
        this.eltabActive = 'etp' + value.StudentID

        this.changeTab('etp' + value.StudentID)
      } else {
        let tabName = 'etp' + value.StudentID
        let tabLabel = value.StudentFullName

        let newTabInfo = {
          CrsID: value.CrsID,
          First_Name: value.First_Name,
          Index_No: value.Index_No,
          Last_Name: value.Last_Name,
          LevelType: value.LevelType,
          Middle_Name: value.Middle_Name,
          NumberOfPlannerDetialsAssigned: value.NumberOfPlannerDetialsAssigned,
          SemID: value.SemID,
          StudentFullName: value.StudentFullName,
          StudentID: value.StudentID,
          TabLabel: tabLabel,
          TabName: tabName,
          SemdID: this.ddlSemesterDetails,
        }

        this.tabDetails.push(newTabInfo)

        this.eltabActive = 'etp' + value.StudentID

        this.changeTab(tabName)

        if (this.tourRunning) {
          this.selectStudentTour = false
          this.$tours['plannerTourName'].currentStep = 5
        }
      }
    },
    assignMultipleStudent() {
      let studentIDValue = ''
      let studentNameValue = ''

      this.multipleStudentSelection.forEach(item => {
        if (studentIDValue === '') {
          studentIDValue = item.StudentID
          studentNameValue = item.StudentFullName
        } else {
          studentIDValue += ',' + item.StudentID
          studentNameValue += ', ' + item.StudentFullName
        }
      })

      let checkIfExistingTab = this.tabDetails.filter(m => m.TabName === 'etp' + studentIDValue)

      if (checkIfExistingTab.length > 0) {
        this.eltabActive = 'etp' + studentIDValue

        this.changeTab('etp' + studentIDValue)

        if (this.tourRunning) {
          this.selectStudentTour = false
          this.$tours['plannerTourName'].currentStep = 5
        }
      } else {
        let tabName = 'etp' + studentIDValue
        let tabLabel = 'Multiple Student'

        let newTabInfo = {
          CrsID: this.multipleStudentSelection[0].CrsID,
          First_Name: '',
          Index_No: '',
          Last_Name: '',
          LevelType: this.multipleStudentSelection[0].LevelType,
          Middle_Name: '',
          NumberOfPlannerDetialsAssigned: '',
          SemID: this.multipleStudentSelection[0].SemID,
          StudentFullName: studentNameValue,
          StudentID: studentIDValue,
          TabLabel: tabLabel,
          TabName: tabName,
          SemdID: this.ddlSemesterDetails,
        }

        this.tabDetails.push(newTabInfo)

        this.eltabActive = 'etp' + studentIDValue

        this.changeTab(tabName)

        if (this.tourRunning) {
          this.selectStudentTour = false
          this.$tours['plannerTourName'].currentStep = 5
        }
      }
    },
    handleTabsEdit(targetName, action) {
      if (action === 'add') {
        // console.log('here add');
      } else if (action === 'remove') {
        let tabs = this.tabDetails
        this.tabDetails = tabs.filter(tab => tab.TabName !== targetName)

        this.eltabActive = 'etpStudentList'
      }
    },
    filterMasterPlannerList() {
      // if (this.ddlSearchMasterPlannerList === '') {
      //     return this.masterPlannerList.filter(data => data.Active === 'True')
      // } else if (this.ddlSearchMasterPlannerList === 'Suggested List') {
      //     return this.masterPlannerList.filter(data => data.Active === 'True' && data.Type === 'Suggested')
      // } else if (this.ddlSearchMasterPlannerList === 'Without Suggest') {
      //     return this.masterPlannerList.filter(data => data.Active === 'True' && data.Type === 'Master')
      // } else if (this.ddlSearchMasterPlannerList === 'Domain' && this.inputSearchMasterPlannerList !== '') {
      //     return this.masterPlannerList.filter(data => data.Active === 'True' && data.Domain.toLowerCase().includes(this.inputSearchMasterPlannerList.toLowerCase()))
      // } else if (this.ddlSearchMasterPlannerList === 'Goals' && this.inputSearchMasterPlannerList !== '') {
      //     return this.masterPlannerList.filter(data => data.Active === 'True' && data.Goals.toLowerCase().includes(this.inputSearchMasterPlannerList.toLowerCase()))
      // } else if (this.ddlSearchMasterPlannerList === 'Indicator' && this.inputSearchMasterPlannerList !== '') {
      //     return this.masterPlannerList.filter(data => data.Active === 'True' && data.Indicator.toLowerCase().includes(this.inputSearchMasterPlannerList.toLowerCase()))
      // } else {
      //     return this.masterPlannerList.filter(data => data.Active === 'True')

      if (this.ddlSearchMasterPlannerList === '') {
        if (this.inputSearchMasterPlannerList === '') {
          return this.masterPlannerList.filter(data => data.Active === 'True')
        } else {
          return this.masterPlannerList.filter(
            data => data.Active === 'True' && data.Indicator.toLowerCase().includes(this.inputSearchMasterPlannerList.toLowerCase()),
          )
        }
      } else {
        if (this.ddlSearchMasterPlannerList === 'Suggested List') {
          if (this.inputSearchMasterPlannerList === '') {
            return this.masterPlannerList.filter(data => data.Active === 'True' && data.Type === 'Suggested')
          } else {
            return this.masterPlannerList.filter(
              data =>
                data.Active === 'True' && data.Type === 'Suggested' && data.Indicator.toLowerCase().includes(this.inputSearchMasterPlannerList.toLowerCase()),
            )
          }
        } else if (this.ddlSearchMasterPlannerList === 'Without Suggest') {
          if (this.inputSearchMasterPlannerList === '') {
            return this.masterPlannerList.filter(data => data.Active === 'True' && data.Type === 'Master')
          } else {
            return this.masterPlannerList.filter(
              data =>
                data.Active === 'True' && data.Type === 'Master' && data.Indicator.toLowerCase().includes(this.inputSearchMasterPlannerList.toLowerCase()),
            )
          }
        } else {
          if (this.inputSearchMasterPlannerList === '') {
            return this.masterPlannerList.filter(
              data => data.Active === 'True' && data.Domain.toLowerCase().includes(this.ddlSearchMasterPlannerList.toLowerCase()),
            )
          } else {
            return this.masterPlannerList.filter(
              data =>
                data.Active === 'True' &&
                data.Indicator.toLowerCase().includes(this.inputSearchMasterPlannerList.toLowerCase()) &&
                data.Domain.toLowerCase().includes(this.ddlSearchMasterPlannerList.toLowerCase()),
            )
          }
        }
      }
    },
    filterMasterPlannerOtherList() {
      // if (this.ddlSearchMasterPlannerOther === '') {
      //     return this.masterPlannerOtherList.filter(data => data.Active === 'True')
      // } else if (this.ddlSearchMasterPlannerOther === 'Domain' && this.inputSearchMasterPlannerOther !== '') {
      //     return this.masterPlannerOtherList.filter(data => data.Active === 'True' && data.Domain.toLowerCase().includes(this.inputSearchMasterPlannerOther.toLowerCase()))
      // } else if (this.ddlSearchMasterPlannerOther === 'Goals' && this.inputSearchMasterPlannerOther !== '') {
      //     return this.masterPlannerOtherList.filter(data => data.Active === 'True' && data.Goals.toLowerCase().includes(this.inputSearchMasterPlannerOther.toLowerCase()))
      // } else if (this.ddlSearchMasterPlannerOther === 'Indicator' && this.inputSearchMasterPlannerOther !== '') {
      //     return this.masterPlannerOtherList.filter(data => data.Active === 'True' && data.Indicator.toLowerCase().includes(this.inputSearchMasterPlannerOther.toLowerCase()))
      // } else {
      //     return this.masterPlannerOtherList.filter(data => data.Active === 'True')
      // }

      if (this.ddlSearchMasterPlannerOther === '') {
        if (this.inputSearchMasterPlannerOther === '') {
          return this.masterPlannerOtherList.filter(data => data.Active === 'True')
        } else {
          return this.masterPlannerOtherList.filter(
            data => data.Active === 'True' && data.Indicator.toLowerCase().includes(this.inputSearchMasterPlannerOther.toLowerCase()),
          )
        }
      } else {
        if (this.inputSearchMasterPlannerOther === '') {
          return this.masterPlannerOtherList.filter(
            data => data.Active === 'True' && data.Domain.toLowerCase().includes(this.ddlSearchMasterPlannerOther.toLowerCase()),
          )
        } else {
          return this.masterPlannerOtherList.filter(
            data =>
              data.Active === 'True' &&
              data.Indicator.toLowerCase().includes(this.inputSearchMasterPlannerOther.toLowerCase()) &&
              data.Domain.toLowerCase().includes(this.ddlSearchMasterPlannerOther.toLowerCase()),
          )
        }
      }
    },
    filterAssignedPlannerList() {
      // if (this.ddlSearchAssignedPlannerList === '') {
      //     return this.assignedPlannerList
      // } else if (this.ddlSearchAssignedPlannerList === 'Suggested List') {
      //     return this.assignedPlannerList.filter(data => data.Type === 'Suggested')
      // } else if (this.ddlSearchAssignedPlannerList === 'Without Suggest') {
      //     return this.assignedPlannerList.filter(data => data.Type === 'Master')
      // } else if (this.ddlSearchAssignedPlannerList === 'Other List') {
      //     return this.assignedPlannerList.filter(data => data.Type === 'Other')
      // } else if (this.ddlSearchAssignedPlannerList === 'Domain' && this.inputSearchAssignedPlannerList !== '') {
      //     return this.assignedPlannerList.filter(data => data.Domain.toLowerCase().includes(this.inputSearchAssignedPlannerList.toLowerCase()))
      // } else if (this.ddlSearchAssignedPlannerList === 'Goals' && this.inputSearchAssignedPlannerList !== '') {
      //     return this.assignedPlannerList.filter(data => data.Goals.toLowerCase().includes(this.inputSearchAssignedPlannerList.toLowerCase()))
      // } else if (this.ddlSearchAssignedPlannerList === 'Indicator' && this.inputSearchAssignedPlannerList !== '') {
      //     return this.assignedPlannerList.filter(data => data.Indicator.toLowerCase().includes(this.inputSearchAssignedPlannerList.toLowerCase()))
      // } else {
      //     return this.assignedPlannerList
      // }

      if (this.ddlSearchAssignedPlannerList === '') {
        if (this.inputSearchAssignedPlannerList === '') {
          return this.assignedPlannerList
        } else {
          return this.assignedPlannerList.filter(data => data.Indicator.toLowerCase().includes(this.inputSearchAssignedPlannerList.toLowerCase()))
        }
      } else {
        if (this.inputSearchAssignedPlannerList === '') {
          return this.assignedPlannerList.filter(data => data.Domain.toLowerCase().includes(this.ddlSearchAssignedPlannerList.toLowerCase()))
        } else {
          return this.assignedPlannerList.filter(
            data =>
              data.Indicator.toLowerCase().includes(this.inputSearchAssignedPlannerList.toLowerCase()) &&
              data.Domain.toLowerCase().includes(this.ddlSearchAssignedPlannerList.toLowerCase()),
          )
        }
      }
    },
    filterMasterOtherLevelPlannerList() {
      if (this.ddlSearchMasterOtherLevelPlannerList === '') {
        if (this.inputSearchMasterOtherLevelPlannerList === '') {
          if (this.ddlSearchMasterOtherLevelPlannerListType === 'ITL') {
            if (this.ddlSearchMasterOtherLevelPlannerListLevel !== '') {
              return this.masterPlannerListOtherLevel.filter(
                data => data.Active === 'True' && data.Type === 'OtherLevelITL' && data.Level === this.ddlSearchMasterOtherLevelPlannerListLevel,
              )
            } else {
              return this.masterPlannerListOtherLevel.filter(data => data.Active === 'True' && data.Type === 'OtherLevelITL')
            }
          } else if (this.ddlSearchMasterOtherLevelPlannerListType === 'Other') {
            if (this.ddlSearchMasterOtherLevelPlannerListLevel !== '') {
              return this.masterPlannerListOtherLevel.filter(
                data => data.Active === 'True' && data.Type === 'OtherLevelOther' && data.Level === this.ddlSearchMasterOtherLevelPlannerListLevel,
              )
            } else {
              return this.masterPlannerListOtherLevel.filter(data => data.Active === 'True' && data.Type === 'OtherLevelOther')
            }
          } else {
            if (this.ddlSearchMasterOtherLevelPlannerListLevel !== '') {
              return this.masterPlannerListOtherLevel.filter(data => data.Active === 'True' && data.Level === this.ddlSearchMasterOtherLevelPlannerListLevel)
            } else {
              return this.masterPlannerListOtherLevel.filter(data => data.Active === 'True')
            }
          }
        } else {
          if (this.ddlSearchMasterOtherLevelPlannerListType === 'ITL') {
            if (this.ddlSearchMasterOtherLevelPlannerListLevel !== '') {
              return this.masterPlannerListOtherLevel.filter(
                data =>
                  data.Active === 'True' &&
                  data.Type === 'OtherLevelITL' &&
                  data.Indicator.toLowerCase().includes(this.inputSearchMasterOtherLevelPlannerList.toLowerCase()) &&
                  data.Level === this.ddlSearchMasterOtherLevelPlannerListLevel,
              )
            } else {
              return this.masterPlannerListOtherLevel.filter(
                data =>
                  data.Active === 'True' &&
                  data.Type === 'OtherLevelITL' &&
                  data.Indicator.toLowerCase().includes(this.inputSearchMasterOtherLevelPlannerList.toLowerCase()),
              )
            }
          } else if (this.ddlSearchMasterOtherLevelPlannerListType === 'Other') {
            if (this.ddlSearchMasterOtherLevelPlannerListLevel !== '') {
              return this.masterPlannerListOtherLevel.filter(
                data =>
                  data.Active === 'True' &&
                  data.Type === 'OtherLevelOther' &&
                  data.Indicator.toLowerCase().includes(this.inputSearchMasterOtherLevelPlannerList.toLowerCase()) &&
                  data.Level === this.ddlSearchMasterOtherLevelPlannerListLevel,
              )
            } else {
              return this.masterPlannerListOtherLevel.filter(
                data =>
                  data.Active === 'True' &&
                  data.Type === 'OtherLevelOther' &&
                  data.Indicator.toLowerCase().includes(this.inputSearchMasterOtherLevelPlannerList.toLowerCase()),
              )
            }
          } else {
            if (this.ddlSearchMasterOtherLevelPlannerListLevel !== '') {
              return this.masterPlannerListOtherLevel.filter(
                data =>
                  data.Active === 'True' &&
                  data.Indicator.toLowerCase().includes(this.inputSearchMasterOtherLevelPlannerList.toLowerCase()) &&
                  data.Level === this.ddlSearchMasterOtherLevelPlannerListLevel,
              )
            } else {
              return this.masterPlannerListOtherLevel.filter(
                data => data.Active === 'True' && data.Indicator.toLowerCase().includes(this.inputSearchMasterOtherLevelPlannerList.toLowerCase()),
              )
            }
          }
        }
      } else {
        if (this.inputSearchMasterOtherLevelPlannerList === '') {
          if (this.ddlSearchMasterOtherLevelPlannerListType === 'ITL') {
            if (this.ddlSearchMasterOtherLevelPlannerListLevel !== '') {
              return this.masterPlannerListOtherLevel.filter(
                data =>
                  data.Active === 'True' &&
                  data.Type === 'OtherLevelITL' &&
                  data.Domain.toLowerCase().includes(this.ddlSearchMasterOtherLevelPlannerList.toLowerCase()) &&
                  data.Level === this.ddlSearchMasterOtherLevelPlannerListLevel,
              )
            } else {
              return this.masterPlannerListOtherLevel.filter(
                data =>
                  data.Active === 'True' &&
                  data.Type === 'OtherLevelITL' &&
                  data.Domain.toLowerCase().includes(this.ddlSearchMasterOtherLevelPlannerList.toLowerCase()),
              )
            }
          } else if (this.ddlSearchMasterOtherLevelPlannerListType === 'Other') {
            if (this.ddlSearchMasterOtherLevelPlannerListLevel !== '') {
              return this.masterPlannerListOtherLevel.filter(
                data =>
                  data.Active === 'True' &&
                  data.Type === 'OtherLevelOther' &&
                  data.Domain.toLowerCase().includes(this.ddlSearchMasterOtherLevelPlannerList.toLowerCase()) &&
                  data.Level === this.ddlSearchMasterOtherLevelPlannerListLevel,
              )
            } else {
              return this.masterPlannerListOtherLevel.filter(
                data =>
                  data.Active === 'True' &&
                  data.Type === 'OtherLevelOther' &&
                  data.Domain.toLowerCase().includes(this.ddlSearchMasterOtherLevelPlannerList.toLowerCase()),
              )
            }
          } else {
            if (this.ddlSearchMasterOtherLevelPlannerListLevel !== '') {
              return this.masterPlannerListOtherLevel.filter(
                data =>
                  data.Active === 'True' &&
                  data.Domain.toLowerCase().includes(this.ddlSearchMasterOtherLevelPlannerList.toLowerCase()) &&
                  data.Level === this.ddlSearchMasterOtherLevelPlannerListLevel,
              )
            } else {
              return this.masterPlannerListOtherLevel.filter(
                data => data.Active === 'True' && data.Domain.toLowerCase().includes(this.ddlSearchMasterOtherLevelPlannerList.toLowerCase()),
              )
            }
          }
        } else {
          if (this.ddlSearchMasterOtherLevelPlannerListType === 'ITL') {
            if (this.ddlSearchMasterOtherLevelPlannerListLevel !== '') {
              return this.masterPlannerListOtherLevel.filter(
                data =>
                  data.Active === 'True' &&
                  data.Type === 'OtherLevelITL' &&
                  data.Indicator.toLowerCase().includes(this.inputSearchMasterOtherLevelPlannerList.toLowerCase()) &&
                  data.Domain.toLowerCase().includes(this.ddlSearchMasterOtherLevelPlannerList.toLowerCase()) &&
                  data.Level === this.ddlSearchMasterOtherLevelPlannerListLevel,
              )
            } else {
              return this.masterPlannerListOtherLevel.filter(
                data =>
                  data.Active === 'True' &&
                  data.Type === 'OtherLevelITL' &&
                  data.Indicator.toLowerCase().includes(this.inputSearchMasterOtherLevelPlannerList.toLowerCase()) &&
                  data.Domain.toLowerCase().includes(this.ddlSearchMasterOtherLevelPlannerList.toLowerCase()),
              )
            }
          } else if (this.ddlSearchMasterOtherLevelPlannerListType === 'Other') {
            if (this.ddlSearchMasterOtherLevelPlannerListLevel !== '') {
              return this.masterPlannerListOtherLevel.filter(
                data =>
                  data.Active === 'True' &&
                  data.Type === 'OtherLevelOther' &&
                  data.Indicator.toLowerCase().includes(this.inputSearchMasterOtherLevelPlannerList.toLowerCase()) &&
                  data.Domain.toLowerCase().includes(this.ddlSearchMasterOtherLevelPlannerList.toLowerCase()) &&
                  data.Level === this.ddlSearchMasterOtherLevelPlannerListLevel,
              )
            } else {
              return this.masterPlannerListOtherLevel.filter(
                data =>
                  data.Active === 'True' &&
                  data.Type === 'OtherLevelOther' &&
                  data.Indicator.toLowerCase().includes(this.inputSearchMasterOtherLevelPlannerList.toLowerCase()) &&
                  data.Domain.toLowerCase().includes(this.ddlSearchMasterOtherLevelPlannerList.toLowerCase()),
              )
            }
          } else {
            if (this.ddlSearchMasterOtherLevelPlannerListLevel !== '') {
              return this.masterPlannerListOtherLevel.filter(
                data =>
                  data.Active === 'True' &&
                  data.Indicator.toLowerCase().includes(this.inputSearchMasterOtherLevelPlannerList.toLowerCase()) &&
                  data.Domain.toLowerCase().includes(this.ddlSearchMasterOtherLevelPlannerList.toLowerCase()) &&
                  data.Level === this.ddlSearchMasterOtherLevelPlannerListLevel,
              )
            } else {
              return this.masterPlannerListOtherLevel.filter(
                data =>
                  data.Active === 'True' &&
                  data.Indicator.toLowerCase().includes(this.inputSearchMasterOtherLevelPlannerList.toLowerCase()) &&
                  data.Domain.toLowerCase().includes(this.ddlSearchMasterOtherLevelPlannerList.toLowerCase()),
              )
            }
          }
        }
      }
    },
    filterPassTermPlanner(semdID) {
      try {
        return this.passTermPlannerDetailsAll.dsPlannerAssignedPassedTermDetails.dsPlannerAssignedPassedTermDetails.filter(data => data.semdID === semdID)
      } catch (e) {
        return []
      }
    },
    AddPlanner(value, mode) {
      let getExistingTabInfo = this.tabDetails.filter(m => m.TabName === this.eltabActive)
      let indexForPassTerms = this.checkPassedTermAssigned(value.Domain, value.Goals, value.Indicator, getExistingTabInfo[0].SemdID, 'Yes')

      //add to assigned list
      let tempAssignedList = {
        Domain: value.Domain,
        Goals: value.Goals,
        Indicator: value.Indicator,
        Type: value.Type,
        AssignedPassTerms: indexForPassTerms,
      }

      this.assignedPlannerList.push(tempAssignedList)
      //add to assigned list

      //set active to false in master list
      this.masterPlannerList = this.masterPlannerList.map(m => {
        if (m.Domain === value.Domain && m.Goals === value.Goals && m.Indicator === value.Indicator) {
          m.Active = 'False'
        }

        return m
      })
      //set active to false in master list

      //set active to false in other list
      this.masterPlannerOtherList = this.masterPlannerOtherList.map(m => {
        if (m.Domain === value.Domain && m.Goals === value.Goals && m.Indicator === value.Indicator) {
          m.Active = 'False'
        }

        return m
      })
      //set active to false in other list

      //set active to false in master list other level
      this.masterPlannerListOtherLevel = this.masterPlannerListOtherLevel.map(m => {
        if (m.Domain === value.Domain && m.Goals === value.Goals && m.Indicator === value.Indicator) {
          m.Active = 'False'
        }

        return m
      })
      //set active to false in master list other level

      if (mode === 'normal') {
        //need approver
        this.checkApprover()
        //need approver

        this.getGroupByDomainList('AssignedList')
        this.getGroupByDomainList('MasterList')
        this.getGroupByDomainList('MasterOtherList')
        this.getGroupByDomainList('MasterListOtherLevel')

        //get filter group by level
        this.getGroupByLevelList('MasterListOtherLevel')
        //get filter group by level
      }
    },
    DeletePlanner(value) {
      //delete from assigned list
      this.assignedPlannerList = this.assignedPlannerList.filter(m => {
        if (m.Domain === value.Domain && m.Goals === value.Goals && m.Indicator === value.Indicator) {
          //no return;
        } else {
          return m
        }
      })
      //delete from assigned list

      //if type not self - set active to true in master list or other list
      if (value.Type !== 'Self') {
        if (value.Type === 'OtherLevelITL' || value.Type === 'OtherLevelOther') {
          this.masterPlannerListOtherLevel = this.masterPlannerListOtherLevel.map(m => {
            if (m.Domain === value.Domain && m.Goals === value.Goals && m.Indicator === value.Indicator) {
              m.Active = 'True'
            }

            return m
          })
        } else if (value.Type === 'Other') {
          this.masterPlannerOtherList = this.masterPlannerOtherList.map(m => {
            if (m.Domain === value.Domain && m.Goals === value.Goals && m.Indicator === value.Indicator) {
              m.Active = 'True'
            }

            return m
          })
        } else {
          this.masterPlannerList = this.masterPlannerList.map(m => {
            if (m.Domain === value.Domain && m.Goals === value.Goals && m.Indicator === value.Indicator) {
              m.Active = 'True'
            }

            return m
          })
        }
      }
      //if type not self - set active to true in master list or other list);

      //need approver
      this.checkApprover()
      //need approver

      this.getGroupByDomainList('AssignedList')
      this.getGroupByDomainList('MasterList')
      this.getGroupByDomainList('MasterOtherList')
      this.getGroupByDomainList('MasterListOtherLevel')

      //get filter group by level
      this.getGroupByLevelList('MasterListOtherLevel')
      //get filter group by level
    },
    changeStudentSelection(val) {
      this.multipleStudentSelection = val

      if (this.tourRunning === true) {
        if (this.multipleStudentSelection.length > 0) {
          if (this.$tours['plannerTourName'].currentStep !== 3) {
            this.selectStudentTour = false
            this.$tours['plannerTourName'].currentStep = 3
          }
        } else {
          this.selectStudentTour = true
          this.$tours['plannerTourName'].currentStep = 2
        }
      }
    },
    getGroupByDomainList(value) {
      let tempObject = {}

      if (value === 'MasterList') {
        // this.ddlSearchMasterPlannerList = '';
        this.ddlSearchMasterPlannerListList = []
        // this.inputSearchMasterPlannerList = '';

        tempObject = {
          Domain: '',
        }
        this.ddlSearchMasterPlannerListList.push(tempObject)

        this.masterPlannerList.forEach(m => {
          if (m.Active === 'True') {
            let checkIfMasterListDomainExisted = this.ddlSearchMasterPlannerListList.filter(m2 => m2.Domain === m.Domain)

            if (checkIfMasterListDomainExisted.length < 1) {
              tempObject = {
                Domain: m.Domain,
              }

              this.ddlSearchMasterPlannerListList.push(tempObject)
            }
          }
        })

        tempObject = {
          Domain: 'Suggested List',
        }
        //  this.ddlSearchMasterPlannerListList.push(tempObject);

        tempObject = {
          Domain: 'Without Suggest',
        }
        //  this.ddlSearchMasterPlannerListList.push(tempObject);

        //check if the domain selection still have in dropdown, if not clear it
        let checkIfMasterListDomainExisted = this.ddlSearchMasterPlannerListList.filter(m2 => m2.Domain === this.ddlSearchMasterPlannerList)

        if (checkIfMasterListDomainExisted.length < 1) {
          this.ddlSearchMasterPlannerList = ''
        }
        //check if the domain selection still have in dropdown, if not clear it
      } else if (value === 'MasterOtherList') {
        // this.ddlSearchMasterPlannerOther = '';
        this.ddlSearchMasterPlannerOtherList = []
        // this.inputSearchMasterPlannerOther = '';

        tempObject = {
          Domain: '',
        }
        this.ddlSearchMasterPlannerOtherList.push(tempObject)

        this.masterPlannerOtherList.forEach(m => {
          if (m.Active === 'True') {
            let checkIfMasterOtherListDomainExisted = this.ddlSearchMasterPlannerOtherList.filter(m2 => m2.Domain === m.Domain)

            if (checkIfMasterOtherListDomainExisted.length < 1) {
              tempObject = {
                Domain: m.Domain,
              }

              this.ddlSearchMasterPlannerOtherList.push(tempObject)
            }
          }
        })

        //check if the domain selection still have in dropdown, if not clear it
        let checkIfMasterOtherListDomainExisted = this.ddlSearchMasterPlannerOtherList.filter(m2 => m2.Domain === this.ddlSearchMasterPlannerOther)

        if (checkIfMasterOtherListDomainExisted.length < 1) {
          this.ddlSearchMasterPlannerOther = ''
        }
        //check if the domain selection still have in dropdown, if not clear it
      } else if (value === 'AssignedList') {
        // this.ddlSearchAssignedPlannerList = '';
        this.ddlSearchAssignedPlannerListList = []
        // this.inputSearchAssignedPlannerList = '';

        tempObject = {
          Domain: '',
        }
        this.ddlSearchAssignedPlannerListList.push(tempObject)

        this.assignedPlannerList.forEach(m => {
          let checkIfAssignedListDomainExisted = this.ddlSearchAssignedPlannerListList.filter(m2 => m2.Domain === m.Domain)

          if (checkIfAssignedListDomainExisted.length < 1) {
            tempObject = {
              Domain: m.Domain,
            }

            this.ddlSearchAssignedPlannerListList.push(tempObject)
          }
        })

        //check if the domain selection still have in dropdown, if not clear it
        let checkIfAssignedListDomainExisted = this.ddlSearchAssignedPlannerListList.filter(m2 => m2.Domain === this.ddlSearchAssignedPlannerList)

        if (checkIfAssignedListDomainExisted.length < 1) {
          this.ddlSearchAssignedPlannerList = ''
        }
        //check if the domain selection still have in dropdown, if not clear it
      } else if (value === 'MasterListOtherLevel') {
        this.ddlSearchMasterOtherLevelPlannerListList = []

        tempObject = {
          Domain: '',
        }
        this.ddlSearchMasterOtherLevelPlannerListList.push(tempObject)

        this.masterPlannerListOtherLevel.forEach(m => {
          if (m.Active === 'True') {
            let checkIfMasterOtherLevelDomainExisted = this.ddlSearchMasterOtherLevelPlannerListList.filter(m2 => m2.Domain === m.Domain)

            if (checkIfMasterOtherLevelDomainExisted.length < 1) {
              tempObject = {
                Domain: m.Domain,
              }

              this.ddlSearchMasterOtherLevelPlannerListList.push(tempObject)
            }
          }
        })

        //check if the domain selection still have in dropdown, if not clear it
        let checkIfMasterOtherLevelDomainExisted = this.ddlSearchMasterOtherLevelPlannerListList.filter(
          m2 => m2.Domain === this.ddlSearchMasterOtherLevelPlannerList,
        )

        if (checkIfMasterOtherLevelDomainExisted.length < 1) {
          this.ddlSearchMasterOtherLevelPlannerList = ''
        }
        //check if the domain selection still have in dropdown, if not clear it
      }
    },
    getGroupByLevelList(value) {
      let tempObject = {}

      if (value === 'MasterListOtherLevel') {
        this.ddlSearchMasterOtherLevelPlannerListLevelList = []

        tempObject = {
          Level: '',
        }
        this.ddlSearchMasterOtherLevelPlannerListLevelList.push(tempObject)

        this.masterPlannerListOtherLevel.forEach(m => {
          if (m.Active === 'True') {
            let checkIfMasterOtherLevelLevelExisted = this.ddlSearchMasterOtherLevelPlannerListLevelList.filter(m2 => m2.Level === m.Level)

            if (checkIfMasterOtherLevelLevelExisted.length < 1) {
              tempObject = {
                Level: m.Level,
              }

              this.ddlSearchMasterOtherLevelPlannerListLevelList.push(tempObject)
            }
          }
        })

        //check if the domain selection still have in dropdown, if not clear it
        let checkIfMasterOtherLevelLevelExisted = this.ddlSearchMasterOtherLevelPlannerListLevelList.filter(
          m2 => m2.Level === this.ddlSearchMasterOtherLevelPlannerListLevel,
        )

        if (checkIfMasterOtherLevelLevelExisted.length < 1) {
          this.ddlSearchMasterOtherLevelPlannerListLevel = ''
        }
        //check if the domain selection still have in dropdown, if not clear it
      }
    },
    checkApprover() {
      let checkApprover = false

      let checkIfNeedApprover = this.assignedPlannerList.filter(m => m.Type === 'OtherLevelOther' || m.Type === 'OtherLevelITL')

      if (checkIfNeedApprover.length > 0) {
        if (this.assignedPlannerListInDB.length < 1) {
          checkApprover = true
        } else {
          checkIfNeedApprover.forEach(m => {
            let checkIfNeedApproverCompareWithAssignedInDB = this.assignedPlannerListInDB.filter(
              m2 => m.Domain === m2.PlnStaDomain && m.Goals === m2.PlnStaGoals && m.Indicator === m2.PlnStaIndicator,
            )

            if (checkIfNeedApproverCompareWithAssignedInDB.length < 1) {
              checkApprover = true
            }

            if (checkApprover === true) {
              return
            }
          })
        }
      }

      if (checkApprover === true) {
        this.needApprover = true
      } else {
        this.needApprover = false
        this.inputCommentApprover = ''
      }
    },
    checkSelectable(row) {
      return row.Status === 'Active'
    },
    checkPassedTermAssigned(Domain, Goals, Indicator, excludeSemdID, newAddMode) {
      let result = ''

      try {
        if (Object.keys(this.passTermPlannerDetailsAll.dsPassedTermInfo).length > 0) {
          this.passTermPlannerDetailsAll.dsPassedTermInfo.dsPassedTermInfo.forEach((m, index) => {
            if (newAddMode === 'Yes' && excludeSemdID === m.semdID) {
              if (result === '') {
                result = index
              } else {
                result += ',' + index
              }
            } else if (excludeSemdID !== m.semdID) {
              //check if existing in pass term assigned
              let checkIfExisting = this.passTermPlannerDetailsAll.dsPlannerAssignedPassedTermDetails.dsPlannerAssignedPassedTermDetails.filter(
                m2 => m2.Domain === Domain && m2.Goals === Goals && m2.Indicator === Indicator && m.semdID === m2.semdID,
              )

              // finalIndex = index + 1;
              if (checkIfExisting.length > 0) {
                if (result === '') {
                  result = index
                } else {
                  result += ',' + index
                }
              }
            }
          })
        }
      } catch (e) {
        return ''
      }

      return result
    },
    checkContain(value, includeMatchValue) {
      if (value.toString().includes(includeMatchValue.toString())) {
        return true
      } else {
        return false
      }
    },
    viewProgress(value) {
      let currentClassID = this.ddlClass.split(',')

      // this.$router.push({
      //     name: 'Planner Student Progress',
      //     params: {
      //         studentID: value.StudentID,
      //         classID: currentClassID[2],
      //         semdID: this.ddlSemesterDetails,
      //         semID: value.SemID,
      //     }
      // });
      let objPP = {}
      objPP.studentID = value.StudentID
      objPP.classID = currentClassID[2]
      objPP.semdID = this.ddlSemesterDetails
      objPP.semID = value.SemID
      objPP.levelType = value.LevelType
      objPP.StudentFullName = value.StudentFullName
      // "studentID","classID","semdID","levelType","StudentFullName"
      this.$router.push({
        name: 'Planner Student Progress',
        params: {
          studentID: value.StudentID,
          classID: currentClassID[2],
          semdID: this.ddlSemesterDetails,
          semID: value.SemID,
          levelType: value.LevelType,
          StudentFullName: value.StudentFullName,
        },
      })

      // this.$router.push({name: 'Planner Student Progress', params: {
      //   studentID: objPP.studentID,
      //     classID: objPP.classID,
      //     semdID: objPP.semdID,
      //     semID:  objPP.semdID,
      //     levelType:  objPP.levelType,
      //     StudentFullName:  objPP.StudentFullName
      // }});
      // this.$emit("paramPlannerProgress", objPP);
    },
    LoadGoals() {
      this.ddlGoalsList = []
      this.ddlGoals = ''
      this.indicator = ''

      this.masterPlannerList.forEach(m => {
        if (m.Domain === this.dllDomain) {
          let checkIfDdlGoalsListExisting = this.ddlGoalsList.filter(m2 => m2.Goals === m.Goals && m2.Domain === this.dllDomain)

          if (checkIfDdlGoalsListExisting.length < 1) {
            let tempDdlGoalsList = {
              Domain: this.dllDomain,
              Goals: m.Goals,
            }

            this.ddlGoalsList.push(tempDdlGoalsList)
          }
        }
      })
    },
    AddSelfPlanner() {
      if (this.dllDomain !== '' && this.ddlGoals !== '' && this.indicator !== '') {
        let checkIfAssignedListExiting = this.assignedPlannerList.filter(m => m.Indicator === this.indicator)

        if (checkIfAssignedListExiting.length < 1) {
          let getExistingTabInfo = this.tabDetails.filter(m => m.TabName === this.eltabActive)
          let indexForPassTerms = this.checkPassedTermAssigned(this.dllDomain, this.ddlGoals, this.indicator, getExistingTabInfo[0].SemdID, 'Yes')

          let tempAssignedList = {
            Domain: this.dllDomain,
            Goals: this.ddlGoals,
            Indicator: this.indicator,
            Type: 'Self',
            AssignedPassTerms: indexForPassTerms,
          }

          this.assignedPlannerList.push(tempAssignedList)

          this.dllDomain = ''
          this.ddlGoalsList = []
          this.ddlGoals = ''
          this.indicator = ''
        } else {
          this.$notify({
            title: 'Duplicated',
            message: 'Unable to add duplicated planner...',
          })
        }
      }
    },
    async copyPlanner() {
      let ddlClassObj = this.ddlCopyClass.split(',')
      let assignedList = await this.getStudentPlannerDetails(this.ddlCopyStudent, ddlClassObj[0], ddlClassObj[1], this.ddlSemesterDetails)

      assignedList.forEach((m, index) => {
        let check = this.assignedPlannerList.filter(m2 => m.PlnStaDomain === m2.Domain && m.PlnStaGoals === m2.Goals && m.PlnStaIndicator === m2.Indicator)

        if (check.length < 1) {
          let currentType = ''
          let checkIfMasterListInAssignedList = this.masterPlannerList.filter(
            m2 => m2.Domain === m.PlnStaDomain && m2.Goals === m.PlnStaGoals && m2.Indicator === m.PlnStaIndicator,
          )
          let checkIfMasterOtherListInAssignedList = this.masterPlannerOtherList.filter(
            m3 => m3.Domain === m.PlnStaDomain && m3.Goals === m.PlnStaGoals && m3.Indicator === m.PlnStaIndicator,
          )
          let checkIfMasterListOtherLevelInAssignedList = this.masterPlannerListOtherLevel.filter(
            m6 => m6.Domain === m.PlnStaDomain && m6.Goals === m.PlnStaGoals && m6.Indicator === m.PlnStaIndicator,
          )

          if (checkIfMasterListInAssignedList.length > 0) {
            currentType = checkIfMasterListInAssignedList[0].Type
          } else if (checkIfMasterOtherListInAssignedList.length > 0) {
            currentType = checkIfMasterOtherListInAssignedList[0].Type
          } else if (checkIfMasterListOtherLevelInAssignedList.length > 0) {
            currentType = checkIfMasterListOtherLevelInAssignedList[0].Type
          } else {
            currentType = 'Self'
          }

          let valueToAdd = {
            Domain: m.PlnStaDomain,
            Goals: m.PlnStaGoals,
            Indicator: m.PlnStaIndicator,
            Type: currentType,
          }

          if (index + 1 === assignedList.length) {
            this.AddPlanner(valueToAdd, 'normal')
          } else {
            this.AddPlanner(valueToAdd, 'copy')
          }
        }
      })
    },
    CopyClassChange() {
      this.ddlCopyStudentList = []
      this.ddlCopyStudent = ''

      this.LoadClassList('copy')
    },
    plannerTourStart() {
      this.tourRunning = true
      this.$tours['plannerTourName'].start()
    },
    plannerTourNexPreviousStep(tour, nextOrPreviousStep) {
      let nextStep = 0

      if (nextOrPreviousStep === 'Next') {
        if (tour.currentStep === 1 && this.studentPlannerSummaryInt.length < 1) {
          return
        } else if (tour.currentStep === 2 && this.multipleStudentSelection.length < 1) {
          return
        } else if (tour.currentStep === 4) {
          return
        } else {
          tour.nextStep()
          nextStep = tour.currentStep + 1
        }
      } else if (nextOrPreviousStep === 'Previous') {
        if (tour.currentStep === 5) {
          return
        } else {
          tour.previousStep()
          nextStep = tour.currentStep - 1
        }
      } else if (nextOrPreviousStep === 'Stop') {
        this.tourRunning = false
        tour.stop()
        nextStep = 9999
      }

      if (nextStep === 2) {
        this.selectStudentTour = true
      } else {
        this.selectStudentTour = false
      }
    },
  },
}
</script>

<style scoped>
.container {
  width: 98%;
  min-width: 98%;
  max-width: 98%;
}
.actionDiv {
  text-align: right;
  color: #364de9;
}
.assignedPlannerDelete,
.assignedPlannerAdd {
  cursor: pointer;
}
.divMasterPlannerListDesc,
.divAssignedPlannerListDesc {
  text-align: left;
}
.labelDisplayInline {
  display: inline !important;
}
.divSelectDomain,
.divSelectGoals,
.divKeyInKeySkillorCld,
.divCopySelectClass,
.divCopySelectStudent {
  margin-bottom: 20px;
}
.dllDomain,
.ddlGoals,
.inputKeySkillCLD,
.ddlCopyClass,
.ddlCopyStudent {
  width: 100%;
}
.divSearchMasterPlannerList,
.divSearchAssignedPlannerList {
  text-align: left;
  margin: 20px 0 20px 0;
}
.divAssignMultipleStudent {
  text-align: right;
}
.bcardStudentAssignStudent {
  height: 800px;
  overflow: scroll;
}
.divPlannerAssignStudentSaveButton {
  margin-top: 20px;
  text-align: right;
}
.filterArea {
  padding: 10px;
  background-color: #e7e3e4;
  border-radius: 10px;
}
.filterAreaDropDown {
  margin-bottom: 10px;
}
.filterDDL {
  width: 100%;
}
.filterAreaInput input {
  margin-bottom: 0px;
}
.iconDisableColor {
  color: #ebeae9;
}
.redBorder {
  border: 1px red solid;
}

/*For the color palette */
.grid-container {
  display: grid;
  grid-template-columns: auto auto;
}
.grid-item {
  border: 1px solid rgba(0, 0, 0, 0.8);
  font-size: 0px;
}
.grid-item-1 {
  background-color: #ffdee6;
}
.grid-item-2 {
  background-color: #ecffc0;
}
.grid-item-3 {
  background-color: #d9fff1;
}
.grid-item-4 {
  background-color: #ded6fc;
}
/*For the color palette */
</style>

<style>
#plannerAssignStudentPageElTab .el-tabs__nav-scroll {
  background-color: #ffffff;
  padding: 0 20px 0 20px;
}
#plannerAssignStudentPageElTab .el-tabs__item {
  font-weight: bold;
}
#plannerAssignStudentPageElTab .el-tab-pane {
  background-color: #ffffff;
  padding: 20px;
}
#plannerAssignStudentPageElTab .el-tabs__item.is-active {
  color: #303133;
}
#plannerAssignStudentPageElTab .el-tabs__item {
  color: #bfc9ca;
}
#plannerAssignStudentPageElTab #tab-etpStudentList .el-icon-close {
  display: none;
}

/*For the color palette */
#plannerAssignStudent .bcardStudentAssignStudent2 .tabs .card-header ul li:nth-child(1) a {
  background-color: #ffdee6 !important;
}
#plannerAssignStudent .bcardStudentAssignStudent2 .tabs .card-header ul li:nth-child(2) a {
  background-color: #ecffc0 !important;
}
#plannerAssignStudent .bcardStudentAssignStudent2 .tabs .card-header ul li:nth-child(3) a {
  background-color: #d9fff1 !important;
}
#plannerAssignStudent .bcardStudentAssignStudent2 .tabs .card-header ul li:nth-child(4) a {
  background-color: #ded6fc !important;
}
#plannerAssignStudent .bcardStudentAssignStudent2 .nav-link.active {
  color: #ff9600 !important;
  font-size: 20px;
  border-radius: 15px;
}
/*For the color palette */
</style>
